<script>

import SelectSchoolScreen from './widgetcomponents/0100/screens/select-school-screen'
import GroupMessagesScreen from './widgetcomponents/0100/screens/group-messages-screen'
import GroupMembersScreen from './widgetcomponents/0100/screens/group-members-screen'
import MessageRecipientsScreen from './widgetcomponents/0100/screens/message-recipients-screen'
import NewGroupMessageScreen from './widgetcomponents/0100/screens/new-group-message-screen'
import SelectRecipientsScreen from './widgetcomponents/0100/screens/select-recipients-screen'
import MessageSuccessScreen from './widgetcomponents/0100/screens/message-success-screen'
import UnauthorizedScreen from './widgetcomponents/0100/screens/unauthorized-screen'
import ErrorScreen from './widgetcomponents/0100/screens/error-screen'
import Spinner from './widgetcomponents/0100/components/spinner'
import GroupMessage from './widgetcomponents/0100/components/group-message'
import RecipientType from './widgetcomponents/0100/components/recipient-type'
import Search from './widgetcomponents/0100/components/search'
import ConsentBox from './widgetcomponents/0100/components/consent-box'
import MessageValidationErrorsModal from './widgetcomponents/0100/components/message-validation-errors-modal'
import ConfirmSendMessageModal from './widgetcomponents/0100/components/confirm-send-message-modal'
import SelectFromClass from './widgetcomponents/0100/components/select-from-class'
import MessageForm from './widgetcomponents/0100/components/message-form'
import ConfirmBackModal from './widgetcomponents/0100/components/confirm-back-modal'
import Footer from './widgetcomponents/0100/footer'
import TRANSLATIONS from './widgetcomponents/0100/translations'
import { interpolate, query } from './widgetcomponents/0100/util'

// const BASE_URL = 'http://localhost:9000' // Thomas
// const BASE_URL = 'https://api.test' // Nikulás
const BASE_URL = 'https://api.subit.dk' // Production
const CLIENT_NAME = 'aula-sms-widget'
const CLIENT_VERSION = 1
const DEFAULT_LANGUAGE = 'da'
const LOCAL_STORAGE_TOKEN_KEY = 'subit_token'
const LOCAL_STORAGE_TOKEN_EXPIRES_KEY = 'subit_token_expires'
const LOCAL_STORAGE_LANGUAGE_KEY = 'subit_language'

class RequestError extends Error {

  constructor(metaData) {
    super(`Http request error: ${metaData.method} ${metaData.url}`)
    this.metaData = metaData
  }
}

export default {
  props: {
    getAulaToken: Function,
    moment: Function,
    axios: Function,
  },
  components: {
    'select-school-screen': SelectSchoolScreen,
    'group-messages-screen': GroupMessagesScreen,
    'group-members-screen': GroupMembersScreen,
    'message-recipients-screen': MessageRecipientsScreen,
    'new-group-message-screen': NewGroupMessageScreen,
    'select-recipients-screen': SelectRecipientsScreen,
    'message-success-screen': MessageSuccessScreen,
    'spinner': Spinner,
    'group-message': GroupMessage,
    'recipient-type': RecipientType,
    'search': Search,
    'consent-box': ConsentBox,
    'error-screen': ErrorScreen,
    'unauthorized-screen': UnauthorizedScreen,
    'message-validation-errors-modal': MessageValidationErrorsModal,
    'confirm-send-message-modal': ConfirmSendMessageModal,
    'select-from-class': SelectFromClass,
    'message-form': MessageForm,
    'confirm-back-modal': ConfirmBackModal,
    'widget-footer': Footer,
  },
  data() {
    return {
      user: null,
      language: localStorage.getItem(LOCAL_STORAGE_LANGUAGE_KEY) || DEFAULT_LANGUAGE,
      TRANSLATIONS,
      isMinimized: true,
      isUntouched: true,
      isPerformingFirstLoad: false,
      hasPerformedFirstLoad: false,
      openScreen: 'select-school-screen',
      previousScreen: 'select-school-screen',
      isGroupsLoading: false,
      isNewMessageLoading: false,
      selected: this.getSelectedStateBoilerPlate(),
      selectedSchool: null, // Not possible to send message without selecting a school
      shownBlacklistReasons: null,
      aulaToken: null,
      schools: {},
      users: {},
      classes: {},
      groups: {},
      removedSelectedRecipients: this.getSelectedStateBoilerPlate(), // state to hold selected people temporarily after they have been removed to make it possible to undo removal
      newMessage: '',
      newMessageErrors: [],
      newMessageGroupName: '',
      isNewMessageConfirmModalOpen: false,
      isNewMessageErrorModalOpen: false,
      isConfirmBackModalOpen: false,
      selectRecipientsMode: 'people',
      recipientSearch: '',
      classSearch: '',
      groupSearch: '',
      selectedGroup: null,
      selectedGroupMessages: [],
      selectedMessage: null,
      selectedMessageStatuses: {},
      selectedMessageStatusFilters: [],
      isIndividualMessageRecipientsOpen: false,
      isPeopleStatusesOverlayOpen: false,
      isValidGsmMessage: true,
    }
  },
  mounted() {

    this.aulaToken = this.getAulaToken()

    setInterval(async () => {

      const newMessagesIds = Object.values(this.selectedGroupMessages)
        .filter(message => this.moment().diff(message.created_at, 'seconds') < 300)
        .map(innerMessage => innerMessage.id)

      if (newMessagesIds.length > 0) {
        this.refreshMessages(newMessagesIds)
      }

      if (this.selectedMessage && newMessagesIds.includes(this.selectedMessage.id)) {
        this.selectedMessageStatuses = await this.fetchMessageStatuses(this.selectedMessage.id)
      }

    }, 20000)
  },
  watch: {
    aulaToken: function() {
      if (this.aulaToken != undefined && Object.keys(this.aulaToken).length > 0) {
        this.initRender()
      }
    },
    openScreen: function() {
      setTimeout(this.scrollMessagesToBottom, 100)
    },
  },
  methods: {

    interpolate,
    async initRender() {

    },

    async reportError(error) {

      console.error('Unexpected error')
      console.error(error)

      try {

        const traceAsArray = error.stack
          .split('\n')
          .map(line => line.trim())
          .map((line) => {
            return /^at ((.*?)(?: \[as (.*?)\])? \((.*?):([0-9]+):([0-9]+)\)|(.*?):([0-9]+):([0-9]+))$/.exec(line)
          })
          .filter(line => line)
          .map((line) => {
            return {
              function: line[3] || line[2] || line[7],
              file: line[4],
              line: parseInt(line[5] || line[8]),
              character: parseInt(line[6] || line[9]),
            }
          })

        const payload = {
          payloadVersion: 5,
          notifier: {
            name: CLIENT_NAME,
            version: CLIENT_VERSION,
            url: 'https://subit.dk',
          },
          events: [{
            user: {
              userId: this.user?.id,
              uniId: this.user?.provider_id,
              schoolId: this.selectedSchool?.id,
            },
            metaData: {
              httpRequest: error.metaData || {},
            },
            app: {
              version: CLIENT_VERSION,
            },
            exceptions: [
              {
                errorClass: error.message,
                stacktrace: traceAsArray.map(frame => ({
                  file: frame.file,
                  lineNumber: frame.line,
                  columnNumber: frame.character,
                  method: frame.function,
                })),
              },
            ],
          }],
        }

        this.getResponseDataOrThrow(await this.postJson('/proxy/bugsnag', payload, {
          headers: {
            'Content-Type': 'application/json',
            'Bugsnag-Api-Key': '0d385a466567cb8c4084bcbdfaa92de9',
            'Bugsnag-Payload-Version': 5,
          },
          transformRequest: (data, headers) => {
            delete headers.common
            return data
          },
        }))

      } catch (error) {
        console.error('Could not report error')
        console.error(error)
      }
    },
    scrollMessagesToBottom() {
      if (this.openScreen === 'group-messages-screen') {
        const container = document.getElementById('group-messages-list')
        container.scrollTop = container.clientHeight + 2000
      }
    },
    async requestJson(method, url, options = {}) {

      try {
        const response = await this.axios.request({
          url,
          method,
          ...options,
          validateStatus() {
            return true
          },
        })

        return {
          response,
          data: response.data.data,
          content: response.data,
          status: response.status,
          successful: response.status >= 200 && response.status < 300,
          url,
          method,
          options,
        }

      } catch (e) {

        throw new RequestError({
          message: e.message,
          url,
          method,
          options,
        })
      }
    },
    async getResponseDataOrThrow(response) {
      if (!response.successful) {
        const copy = { ...response }
        delete copy.response
        throw new RequestError(copy)
      }

      return response.data
    },
    async getJson(url, options = {}) {
      return this.requestJson('GET', url, options)
    },
    async postJson(url, body, options = {}) {
      return await this.requestJson('POST', url, {
        ...options,
        headers: {
          ...(options.headers || {}),
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(body),
      })
    },
    async patchJson(url, body, options = {}) {
      return await this.requestJson('PATCH', url, {
        ...options,
        headers: {
          ...(options.headers || {}),
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(body),
      })
    },
    async fetchMe() {

      this.user = await this.getResponseDataOrThrow(
        await this.getJson('/v2/me'),
      )

      const language = TRANSLATIONS[this.user.language]
        ? this.user.language
        : DEFAULT_LANGUAGE

      this.language = language
      localStorage.setItem(LOCAL_STORAGE_LANGUAGE_KEY, language)
    },
    async fetchSchools() {
      return this.getResponseDataOrThrow(
        await this.getJson('/v2/schools'),
      )
    },
    async fetchUsers(schoolId) {
      return this.getResponseDataOrThrow(
        await this.getJson(`/v2/communication/schools/${schoolId}/users`),
      )
    },
    async fetchClasses(schoolId) {
      return this.getResponseDataOrThrow(
        await this.getJson(`/v2/communication/schools/${schoolId}/classes`),
      )
    },
    async fetchGroups(schoolId) {
      return this.getResponseDataOrThrow(
        await this.getJson(`/v2/communication/schools/${schoolId}/groups`),
      )
    },
    async fetchMessages(groupId, parameters = {}) {
      const messages = await this.getResponseDataOrThrow(
        await this.getJson(`/v2/communication/groups/${groupId}/messages${query(parameters)}`),
      )

      return messages.map(this.enrichMessage)
    },
    async fetchMessageStatuses(messageId) {

      const statuses = await this.getResponseDataOrThrow(
        await this.getJson(`/v2/communication/groups/messages/${messageId}/statuses`),
      )

      const result = {}
      statuses.forEach(status => {

        if (!status.is_received && !status.is_failed) {
          result[status.user_id] = 'pending'
        } else if (status.is_received) {
          result[status.user_id] = 'received'
        } else {
          result[status.user_id] = 'failed'
        }

      })

      return result
    },
    // Fetch users for the selected school and populate the state with data relating to that school
    async selectSchool(school) {

      if (!school.communication) {
        return
      }

      if (school.communication.blacklist_reasons) {
        this.shownBlacklistReasons = school.communication.blacklist_reasons
        return
      }

      this.selectedSchool = school

      try {

        this.isGroupsLoading = true
        const users = await this.fetchUsers(school.id)
        const classes = await this.fetchClasses(school.id)
        const groups = await this.fetchGroups(school.id)

        this.addUsers(users, true)
        this.addClasses(classes, true)
        this.addGroups(groups, true)

        // Reset
        this.isGroupsLoading = false
        this.selected = this.getSelectedStateBoilerPlate()
        this.recipientSearch = ''
        this.selectedGroupMessages = []
        this.openScreen = 'groups-overview-screen'

      } catch (error) {
        this.handleError(error)
      }
    },
    navigate(screen) {
      this.previousScreen = this.openScreen
      this.openScreen = screen
    },
    handleCloseNewGroupMessageScreen() {

      if (!this.newMessageGroupName.length && !this.selectedRecipients.length && !this.newMessage.length) {
        this.navigate('groups-overview-screen')
        return
      }

      // User has made unsaved progress, warn them before navigating
      this.openConfirmBackModal()
    },
    closeNewGroupMessageScreen() {
      // Rest

      this.selected = this.getSelectedStateBoilerPlate()
      this.newMessage = ''
      this.newMessageGroupName = ''
      this.isConfirmBackModalOpen = false
      this.navigate('groups-overview-screen')
    },
    unselectSchool() {
      this.selectedSchool = null
      this.isGroupsLoading = false
      this.selected = this.getSelectedStateBoilerPlate()
      this.recipientSearch = ''
      this.selectedGroupMessages = []
      this.navigate('select-school-screen')
    },
    addClasses(classes, reset = false) {
      if (reset) {
        this.classes = {}
      }

      classes.forEach(_class => {
        this.classes[_class.id] = _class
      })
    },
    addUsers(users, reset = false) {
      if (reset) {
        this.users = {}
      }

      users.forEach(user => {
        this.users[user.id] = user
      })
    },
    addSchools(schools) {
      const keyed = {}
      schools.forEach(school => {
        keyed[school.id] = { ...school, name: school.short_name || school.name }
      })

      this.schools = keyed
    },
    addGroups(groups, reset = false) {

      if (reset) {
        this.groups = {}
      }

      const keyed = {}

      groups
        .map(group => ({ ...group, members: group.members.filter(member => !member.user_id || this.users[member.user_id]) }))
        .filter(group => group.members.length)
        .forEach(group => {
          keyed[group.id] = this.enrichGroup(group)
        })

      this.groups = {
        ...this.groups,
        ...keyed,
      }
    },
    selectGroupMessages(messages) {
      const keyed = {}
      messages.forEach(message => {
        keyed[message.id] = this.enrichMessage(message)
      })

      this.selectedGroupMessages = keyed
    },
    addMessages(messages) {
      const keyed = {}
      messages.forEach(message => {
        keyed[message.id] = this.enrichMessage(message)
      })

      this.selectedGroupMessages = {
        ...this.selectedGroupMessages,
        ...keyed,
      }
    },
    enrichGroup(group) {
      return {
        ...group,
        created_at: this.moment(group.created_at).locale(this.language),
        latest_group_message: group.latest_group_message ? this.enrichMessage(group.latest_group_message) : null,
      }
    },
    enrichMessage(message) {
      return {
        ...message,
        created_at: this.moment(message.created_at).locale(this.language),
      }
    },
    async createGroup() {

      const payload = {
        school_id: this.selectedSchool.id,
        members: this.recipientsFormattedForGroupCreation,
        name: this.newMessageGroupName,
      }

      return this.postJson('/v2/communication/groups', payload)
    },
    async createMessage(groupId) {
      return this.postJson(`/v2/communication/groups/${groupId}/messages/send`, {
        'encoding': this.isValidGsmMessage ? 'gsm7' : 'utf8',
        'text': this.newMessage,
      })
    },
    async handleSelectGroup(groupId) {
      try {
        this.selectedGroup = this.groups[groupId]
        this.selectGroupMessages(await this.fetchMessages(groupId))
        this.navigate('group-messages-screen')
      } catch (error) {
        this.handleError(error)
      }
    },
    async handleUpdateMessages(groupId) {
      try {
        this.addMessages(await this.fetchMessages(groupId))
      } catch (error) {
        this.handleError(error)
      }
    },
    async refreshMessages(ids) {
      try {
        const messages = await this.fetchMessages(this.selectedGroup.id, { ids })
        this.addMessages(messages)
      } catch (error) {
        this.reportError(error)
      }
    },
    async handleOpenMessageRecipientsScreen(message) {
      try {
        this.selectedMessageStatuses = await this.fetchMessageStatuses(message.id)
        this.selectedMessage = message
        this.selectedMessageStatusFilters = []
        this.navigate('message-recipients-screen')
      } catch (error) {
        this.handleError(error)
      }
    },
    getGroupMembers(group) {

      const users = []
      const usersReceivable = []
      const usersConsented = []
      const usersNotReceivable = []
      const usersNotConsented = []
      const usersNoPhoneNumber = []

      const handleAddingUser = (user) => {

        users.push(user)

        if (!user.has_phone_number) {
          usersNoPhoneNumber.push(user)
        }

        if (!user.is_consented) {
          usersNotConsented.push(user)
        }

        if (!user.has_phone_number || !user.is_consented) {
          usersNotReceivable.push(user)
        }

        if (user.has_phone_number && user.is_consented) {
          usersReceivable.push(user)
        }
      }

      if (group) {

        const filters = []
        const individuals = new Set()

        group.members.forEach(member => {

          if (member.relation === 'teachers') {
            filters.push(user => user.roles.some(role => role.type === 'teacher'))
          }

          if (member.relation === 'tutors') {
            filters.push(user => user.roles.some(role => role.type === 'tutor'))
          }

          if (member.relation === 'students') {
            filters.push(user => user.roles.some(role => {
              return role.type === 'student' && (!member.class_id || role.classes.includes(member.class_id))
            }))
          }

          if (member.relation === 'contact_persons') {
            filters.push(user => user.roles.some(role => {
              return role.type === 'contact_person' && (!member.class_id || role.classes.includes(member.class_id))
            }))
          }

          if (member.user_id) {
            individuals.add(member.user_id)
          }
        })

        if (individuals.size > 0) {
          filters.push(user => individuals.has(user.id))
        }

        this.sortedUsers.forEach(user => {
          const isMember = filters.some(filter => filter(user))
          if (isMember) {
            handleAddingUser(user)
          }
        })
      }

      return {
        users,
        usersReceivable,
        usersConsented,
        usersNotReceivable,
        usersNotConsented,
        usersNoPhoneNumber,
      }
    },
    addStatusFilter(status) {
      this.selectedMessageStatusFilters.push(status)
    },
    removeStatusFilter(status) {
      this.selectedMessageStatusFilters = this.selectedMessageStatusFilters.filter(selectedFilter => selectedFilter !== status)
    },
    async giveConsent(users) {

      const url = `/v2/communication/schools/${this.selectedSchool.id}/update-consents`
      const payload = users.map(user => ({
        user_id: user.id,
        is_consented: true,
      }))

      try {
        const updates = await this.getResponseDataOrThrow(await this.patchJson(url, payload))
        updates.forEach(update => {
          if (this.users[update.user_id]) {
            this.users[update.user_id] = { ...this.users[update.user_id], is_consented: update.is_consented }
          }
        })

        this.users = { ...this.users }

      } catch (error) {
        this.handleError(error)
      }
    },
    async performFirstLoad(forceTokenReloadFlag = false) {

      this.isPerformingFirstLoad = true

      try {

        this.axios.defaults.baseURL = BASE_URL
        this.axios.defaults.headers.common['x-client'] = CLIENT_NAME
        this.axios.defaults.headers.common['x-client-version'] = CLIENT_VERSION

        let reloadToken = false
        try {
          const token = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)
          const expire = localStorage.getItem(LOCAL_STORAGE_TOKEN_EXPIRES_KEY)
          if (!token || new Date(expire).getTime() < new Date().getTime()) {
            reloadToken = true
          }
        } catch {
          reloadToken = true
        }

        if (reloadToken || forceTokenReloadFlag) {
          const url = `/v2/auth/aula`
          const payload = { jwt_token: this.aulaToken }

          try {
            const authResponse = await this.getResponseDataOrThrow(
              await this.postJson(url, payload),
            )

            localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, authResponse.access_token)
            localStorage.setItem(LOCAL_STORAGE_TOKEN_EXPIRES_KEY, authResponse.expires_at)
          } catch {
            this.showUnauthorizedScreen()
            return
          }
        }

        this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)

        await this.fetchMe()
        this.addSchools(await this.fetchSchools())

        this.isPerformingFirstLoad = false
        this.hasPerformedFirstLoad = true

      } catch (error) {
        this.handleError(error, forceTokenReloadFlag)
      }
    },
    minimize() {
      this.isMinimized = true
    },
    maximize() {
      this.isMinimized = false
      this.isUntouched = false

      if (!this.hasPerformedFirstLoad) {
        this.performFirstLoad()
      }
    },
    formatGroupActivityTime(time) {

      if (time.isSame(this.moment(), 'day')) {
        return time.format('HH:mm')
      }

      return time.format('DD/MM')
    },
    closeNewMessageConfirmModal() {
      this.isNewMessageConfirmModalOpen = false
    },
    closeNewMessageErrorModal() {
      this.newMessageErrors = []
      this.isNewMessageErrorModalOpen = false
    },
    openConfirmBackModal() {
      this.isConfirmBackModalOpen = true
    },
    closeConfirmBackModal() {
      this.isConfirmBackModalOpen = false
    },
    getSelectedStateBoilerPlate() {
      return {
        contactPersons: null,
        students: null,
        tutors: null,
        teachers: null,
        users: {},
      }
    },
    setRecipientSearch(searchStr) {
      this.recipientSearch = searchStr || ''
    },
    setClassSearch(searchStr) {
      this.classSearch = searchStr || ''
    },
    setGroupSearch(searchStr) {
      this.groupSearch = searchStr || ''
    },
    clearGroupSearch() {
      this.groupSearch = ''
    },
    clearRecipientSearch() {
      this.recipientSearch = ''
    },
    clearClassSearch() {
      this.classSearch = ''
    },
    selectRecipient(user) {
      this.selected.users = {
        ...this.selected.users,
        [user.id]: user,
      }
    },
    unSelectRecipient(user) {
      let state = this.selected.users
      delete state[user.id]

      this.selected.users = { ...state }
    },
    selectAllGroupType(type) {
      this.selected[type] = 'all'
    },
    unSelectAllGroupType(type) {
      this.selected[type] = null
    },
    selectAllGroupTypeByClass(type, _class) {

      if (this.selected[type] === 'all') {
        return null
      }

      this.selected[type] = {
        ...(this.selected[type] || {}),
        [_class.id]: _class,
      }

      if (this.selected[type] && this.selected[type] !== 'all') {
        if (Object.keys(this.selected[type]).length === this.sortedClasses.length) {
          this.selected[type] = 'all'
        }
      }
    },
    unSelectAllGroupTypeByClass(type, _class) {

      if (!this.selected[type]) {
        return null
      }

      let state = this.selected[type]

      if (state === 'all') {
        state = {}
        this.sortedClasses.forEach(currentClass => {
          state[currentClass.id] = currentClass
        })
      }

      state[_class.id] = false

      if (!Object.keys(state).length) {
        state = null
      }

      this.selected[type] = state
    },
    handleError(error, isTokenRefreshed = false) {
      if ((error.response?.status === 401 || error.metaData?.status === 401) && !isTokenRefreshed) {
        this.performFirstLoad(true)
        return
      }

      this.showErrorScreen()
      this.reportError(error)
    },
    showErrorScreen() {
      this.openScreen = 'error-screen'
    },
    showUnauthorizedScreen() {
      this.openScreen = 'unauthorized-screen'
    },
    closeBlacklistReasonsModal() {
      this.shownBlacklistReasons = null
    },
    selectRecipientsByPeople() {
      this.selectRecipientsMode = 'people'
    },
    selectRecipientsByGroup() {
      this.selectRecipientsMode = 'group'
    },
    removeSelectedRecipients() {
      this.removedSelectedRecipients = this.selected
      this.selected = this.getSelectedStateBoilerPlate()

      setTimeout(() => {
        this.removedSelectedRecipients = this.getSelectedStateBoilerPlate()
      }, 10000)
    },
    undoRemoveSelectedRecipients() {
      this.selected = this.removedSelectedRecipients
      this.removedSelectedRecipients = this.getSelectedStateBoilerPlate()
    },
    async attemptSendMessage() {

      this.newMessageErrors = this.validateGroup()
      this.newMessageErrors = this.newMessageErrors.concat(this.validateMessage(this.newMessage))
      if (this.newMessageErrors.length) {
        this.isNewMessageErrorModalOpen = true
        return
      }

      this.isNewMessageConfirmModalOpen = true
    },
    async handleSendMessage() {

      this.isNewMessageLoading = true

      const createGroupResponse = await this.createGroup()
      if (createGroupResponse.status === 403) {
        this.newMessageErrors.push(this.translations.errors.requestBlacklisted)
      } else if (!createGroupResponse.successful) {
        this.newMessageErrors.push(this.translations.errors.requestCreateGroupFailed)
      }

      if (createGroupResponse.successful) {
        const createMessageResponse = await this.createMessage(createGroupResponse.data.id)
        if (createMessageResponse.status === 403) {
          this.newMessageErrors.push(this.translations.errors.requestBlacklisted)
        } else if (!createMessageResponse.successful) {
          this.newMessageErrors.push(this.translations.errors.requestSendMessageFailed)
        }
      }

      if (this.newMessageErrors.length) {
        this.isNewMessageLoading = false
        this.isNewMessageErrorModalOpen = true
        return
      }

      this.addGroups(await this.fetchGroups(this.selectedSchool.id))

      // Navigate to success screen
      this.newMessage = ''
      this.newMessageGroupName = ''
      this.isNewMessageLoading = false
      this.selected = this.getSelectedStateBoilerPlate()
      this.navigate('new-group-message-success-screen')
    },
    async attemptSendMessageToExistingGroup() {

      this.newMessageErrors = this.validateMessage(this.newMessage)
      if (this.newMessageErrors.length) {
        this.isNewMessageErrorModalOpen = true
        return
      }

      this.isNewMessageConfirmModalOpen = true
    },
    async sendMessageToExistingGroup(groupId) {

      const createMessageResponse = await this.createMessage(groupId)
      if (createMessageResponse.status === 403) {
        this.newMessageErrors.push(this.translations.errors.requestBlacklisted)
      } else if (!createMessageResponse.successful) {
        this.newMessageErrors.push(this.translations.errors.requestSendMessageFailed)
      }

      if (this.newMessageErrors.length) {
        this.isNewMessageErrorModalOpen = true
        return
      }

      // Fetch messages again after creating the new message
      const refreshedMessages = await this.fetchMessages(groupId)
      this.addMessages(refreshedMessages)

      if (this.newMessageErrors.length) {
        this.isNewMessageLoading = false
        this.isNewMessageErrorModalOpen = true
        return
      }

      this.newMessageGroupName = ''
      this.newMessage = ''
      this.isNewMessageLoading = false

      const group = this.groups[groupId]
      if (group && refreshedMessages.length > 0) {
        group.latest_group_message = this.enrichMessage(refreshedMessages[refreshedMessages.length - 1])
      }

      setTimeout(this.scrollMessagesToBottom, 100)
    },
    validateGroup() {

      const errors = []

      if (!this.anySelectedRecipients) {
        errors.push(this.translations.errors.noSelectedRecipients)
      }

      if (!this.newMessageGroupName) {
        errors.push(this.translations.errors.missingGroupName)
      }

      if (this.newMessageGroupName && this.newMessageGroupName.length > 100) {
        errors.push(this.translations.errors.groupNameTooLong)
      }

      return errors
    },
    validateMessage(message) {

      const errors = []

      if (!message || message.length < 1) {
        errors.push(this.translations.errors.messageTextEmpty)
      } else if (!this.newMessage.length > 10000) {
        errors.push(this.translations.errors.messageTextTooLong)
      }

      return errors
    },
    handleNewMessageGroupNameChange(name) {
      this.newMessageGroupName = name
    },
    handleNewMessageChange(text) {
      this.newMessage = text
      this.isValidGsmMessage = this.isGsmMessage(this.newMessage)
    },
    openPeopleStatusesOverlay() {
      this.isPeopleStatusesOverlayOpen = true
    },
    closePeopleStatusesOverlay() {
      this.isPeopleStatusesOverlayOpen = false
    },
    isGsmMessage(message) {
      // GSM 7-bit charset
      const gsmCodePoints = new Set([
        0x000a, 0x000c, 0x000d,
        0x0020, 0x0021, 0x0022, 0x0023, 0x0024, 0x0025, 0x0026, 0x0027, 0x0028, 0x0029, 0x002a, 0x002b, 0x002c, 0x002d, 0x002e, 0x002f,
        0x0030, 0x0031, 0x0032, 0x0033, 0x0034, 0x0035, 0x0036, 0x0037, 0x0038, 0x0039, 0x003a, 0x003b, 0x003c, 0x003d, 0x003e, 0x003f,
        0x0040, 0x0041, 0x0042, 0x0043, 0x0044, 0x0045, 0x0046, 0x0047, 0x0048, 0x0049, 0x004a, 0x004b, 0x004c, 0x004d,
        0x004e, 0x004f,
        0x0050, 0x0051, 0x0052, 0x0053, 0x0054, 0x0055, 0x0056, 0x0057, 0x0058, 0x0059, 0x005a, 0x005b, 0x005c, 0x005d, 0x005e, 0x005f,
        0x0061, 0x0062, 0x0063, 0x0064, 0x0065, 0x0066, 0x0067, 0x0068, 0x0069, 0x006a, 0x006b, 0x006c, 0x006d, 0x006e, 0x006f,
        0x0070, 0x0071, 0x0072, 0x0073, 0x0074, 0x0075, 0x0076, 0x0077, 0x0078, 0x0079, 0x007a, 0x007b, 0x007c, 0x007d, 0x007e,
        0x00a1, 0x00a3, 0x00a4, 0x00a5, 0x00a7,
        0x00bf,
        0x00c4, 0x00c5, 0x00c6, 0x00c7, 0x00c9,
        0x00d1, 0x00d6, 0x00d8, 0x00dc, 0x00df,
        0x00e0, 0x00e4, 0x00e5, 0x00e6, 0x00e8, 0x00e9, 0x00ec,
        0x00f1, 0x00f2, 0x00f6, 0x00f8, 0x00f9, 0x00fc,
        0x0393, 0x0394, 0x0398, 0x039b, 0x039e, 0x03a0, 0x03a3, 0x03a6, 0x03a8, 0x03a9,
        0x20ac,
      ])

      for (const character of message) {
        const codePoint = character.codePointAt(0)
        if (codePoint && !gsmCodePoints.has(codePoint)) {
          return false
        }
      }

      return true
    },
  },
  computed: {
    translations: function() {
      return this.TRANSLATIONS[this.language]
    },
    allGroups() {
      return Object.values(this.groups)
    },
    filteredGroups() {

      if (!this.groupSearch || this.groupSearch.length < 1) {
        return Object.values(this.groups)
      }

      const lowerSearch = this.groupSearch.toLowerCase()

      const matchesName = (group) => {
        return group.name && group.name.toLowerCase().includes(lowerSearch)
      }

      const matchesGroupClasses = (group) => {
        return group.members?.some(member => {
          return !!(
            member.class_id &&
            this.classes[member.class_id]?.name &&
            this.classes[member.class_id]?.name.toLowerCase().includes(lowerSearch)
          )
        })
      }

      return this.allGroups.filter(group => (
        matchesName(group) ||
        matchesGroupClasses(group)
      ))
    },
    sortedGroups() {
      return [...this.filteredGroups].sort((a, b) => {
        const aLatestActivity = a.latest_group_message?.created_at || a.created_at
        const bLatestActivity = b.latest_group_message?.created_at || b.created_at
        return bLatestActivity.unix() - aLatestActivity.unix()
      })
    },
    groupMembers() {
      const result = {}
      this.sortedGroups.forEach(group => {
        result[group.id] = this.getGroupMembers(group)
      })

      return result
    },
    selectedGroupMembers() {
      return this.groupMembers[this.selectedGroup?.id]
    },
    selectedGroupMembersWhereConsentable() {
      return this.selectedGroupMembers.users.filter(member => this.consentableUsers[member.id])
    },
    consentableUsers() {
      const result = {}
      this.sortedUsers.forEach(user => {
        result[user.id] = !user.is_consented && user.is_changeable_consent
      })

      return result
    },
    sortedSelectedGroupMessages() {
      return Object.values(this.selectedGroupMessages).sort((a, b) => {
        return a.created_at.unix() - b.created_at.unix()
      })
    },
    selectedGroupMembersFiltered() {
      const members = {}
      this.selectedGroupMembers.users.forEach(user => members[user.id] = true)
      const isMember = user => members[user.id]

      return {
        teachers: this.filteredTeachers.filter(isMember),
        tutors: this.filteredTutors.filter(isMember),
        students: this.filteredStudents.filter(isMember),
        contactPersons: this.filteredContactPersons.filter(isMember),
        inspectors: this.filteredInspectors.filter(isMember),
      }
    },
    // Apply the status filters, nothing to do with the search form
    selectedMessageRecipientsFiltered() {

      if (!this.selectedMessageStatusFilters.length) {
        return this.selectedGroupMembersFiltered
      }

      const includeSuccessful = this.selectedMessageStatusFilters.includes('received')
      const includePending = this.selectedMessageStatusFilters.includes('pending')
      const includeFailed = this.selectedMessageStatusFilters.includes('failed')

      const filter = user => (
        (includeSuccessful && this.selectedMessageStatuses[user.id] === 'received') ||
        (includePending && this.selectedMessageStatuses[user.id] === 'pending') ||
        (includeFailed && this.selectedMessageStatuses[user.id] === 'failed')
      )

      return {
        teachers: this.selectedGroupMembersFiltered.teachers.filter(filter),
        tutors: this.selectedGroupMembersFiltered.tutors.filter(filter),
        students: this.selectedGroupMembersFiltered.students.filter(filter),
        contactPersons: this.selectedGroupMembersFiltered.contactPersons.filter(filter),
        inspectors: this.selectedGroupMembersFiltered.inspectors.filter(filter),
      }
    },
    selectedMessageRecipientsLength() {
      return this.selectedMessageRecipientsFiltered.teachers.length + this.selectedMessageRecipientsFiltered.tutors.length
        + this.selectedMessageRecipientsFiltered.students.length + this.selectedMessageRecipientsFiltered.contactPersons.length
    },
    newMessageLengthDescription() {

      if (this.newMessage.length === 0) {
        return null
      }

      return this.newMessageMessagesAmount <= 1
        ? `${this.charactersInCurrentMessage}`
        : `${this.charactersInCurrentMessage}/${this.newMessageMessagesAmount}`
    },
    newMessageMessagesAmount() {
      return this.newMessage.length <= (this.isValidGsmMessage ? 160 : 70)
        ? 1
        : Math.ceil(this.newMessage.length / (this.isValidGsmMessage ? 153 : 67))
    },
    charactersInCurrentMessage() {

      // 160 upper limit for GSM-7 if one message
      // 153 upper limit for GSM-7 if multiple messages
      // 70  upper limit for UTF-8 if one message
      // 67  upper limit for UTF-8 if multiple messages

      const firstMessageLimit = this.isValidGsmMessage ? 160 : 70
      const followingMessageLimit = this.isValidGsmMessage ? 153 : 67
      if (this.newMessage.length <= firstMessageLimit) {
        return this.newMessage.length
      }

      return this.newMessage.length % followingMessageLimit
    },
    selectedRecipients: function() {

      const filters = [
        (recipient) => this.selected.users[recipient.id],
        (recipient) => this.selected.teachers && recipient.roles.some(role => role.type === 'teacher'),
        (recipient) => this.selected.tutors && recipient.roles.some(role => role.type === 'tutor'),
        (recipient) => {

          if (!this.selected.students) {
            return false
          } else if (this.selected.students === 'all') {
            return recipient.roles.some(role => role.type === 'student')
          } else {
            return recipient.roles.some(role => (
              role.type === 'student' &&
              role.classes &&
              role.classes.some(classId => this.selected.students[classId])
            ))
          }
        },
        (recipient) => {

          if (!this.selected.contactPersons) {
            return false
          } else if (this.selected.contactPersons === 'all') {
            return recipient.roles.some(role => role.type === 'contact_person')
          } else {
            return recipient.roles.some(role => (
              role.type === 'contact_person' &&
              role.classes &&
              role.classes.some(classId => this.selected.contactPersons[classId])
            ))
          }
        },
      ]

      return this.sortedUsers.filter(recipient => filters.some(filter => filter(recipient)))
    },
    selectedRecipientsReceivable() {
      return this.selectedRecipients.filter(recipient => {
        return recipient.is_consented && recipient.has_phone_number
      })
    },
    selectedRecipientsNotReceivable() {
      const unique = {}

      this.selectedRecipientsWithoutConsent.forEach(user => unique[user.id] = user)
      this.selectedRecipientsWithoutPhone.forEach(user => unique[user.id] = user)

      return Object.values(unique)
    },
    selectedRecipientsWithoutConsent() {
      return this.selectedRecipients.filter(recipient => !recipient.is_consented)
    },
    selectedRecipientsWithoutPhone() {
      return this.selectedRecipients.filter(recipient => !recipient.has_phone_number)
    },
    anySelectedRecipients() {
      return !!(
        this.selected.contactPersons ||
        this.selected.students ||
        this.selected.tutors ||
        this.selected.teachers ||
        Object.values(this.selected.users).length > 0
      )
    },
    selectedRecipientsWhereConsentCanBeGiven() {
      return this.selectedRecipients.filter(recipient => (
        !recipient.is_consented &&
        recipient.is_changeable_consent
      ))
    },
    usersWhereConsentCanBeGiven() {
      return this.sortedUsers.filter(recipient => (
        !recipient.is_consented &&
        recipient.is_changeable_consent
      ))
    },
    giveConsentUsers() {
      return this.anySelectedRecipients
        ? this.selectedRecipientsWhereConsentCanBeGiven
        : this.usersWhereConsentCanBeGiven
    },
    isRemovedSelectedRecipientsNotEmpty: function() {
      if (this.removedSelectedRecipients.contactPersons || this.removedSelectedRecipients.students
        || this.removedSelectedRecipients.tutors || this.removedSelectedRecipients.teachers) {
        return true
      }

      return !!Object.keys(this.removedSelectedRecipients.users).length
    },
    recipientsFormattedForGroupCreation: function() {

      const recipients = []

      if (this.selected.teachers === 'all') {
        recipients.push({ relation: 'teachers' })
      }

      if (this.selected.tutors === 'all') {
        recipients.push({ relation: 'tutors' })
      }

      Object.keys(this.selected.users).forEach(recipientId => {
        recipients.push({ user_id: parseInt(recipientId) })
      })

      if (this.selected.students === 'all') {
        recipients.push({ relation: 'students' })
      } else if (this.selected.students) {
        Object.entries(this.selected.students).forEach(([classId, include]) => {
          if (include) {
            recipients.push({ relation: 'students', class_id: parseInt(classId) })
          }
        })
      }

      if (this.selected.contactPersons === 'all') {
        recipients.push({ relation: 'contact_persons' })
      } else if (this.selected.contactPersons) {
        Object.entries(this.selected.contactPersons).forEach(([classId, include]) => {
          if (include) {
            recipients.push({ relation: 'contact_persons', class_id: parseInt(classId) })
          }
        })
      }

      return recipients
    },
    sortedUsers() {
      return Object.values(this.users).sort((a, b) => {

        const aName = a.name || ''
        const bName = b.name || ''
        const aNamePresent = aName !== ''
        const bNamePresent = bName !== ''

        if (!aNamePresent && !bNamePresent) {
          return 0
        }

        if (aNamePresent !== bNamePresent) {
          return aNamePresent ? -1 : 1
        }

        return a.name.localeCompare(b.name)
      })
    },
    filteredRecipients() {

      const lowerCaseSearch = this.recipientSearch.toLowerCase()
      if (lowerCaseSearch.length < 1) {
        return this.sortedUsers
      }

      const matchesName = (user) => {
        return user.name && user.name.toLowerCase().includes(lowerCaseSearch)
      }

      const matchesProviderId = (user) => {
        return user.provider_id && user.provider_id === lowerCaseSearch
      }

      const matchesInitials = (user) => {
        return user.roles.some(role => {
          return role.initials && role.initials.toLowerCase().includes(lowerCaseSearch)
        })
      }

      const matchesClassName = (user) => {
        return user.roles.some(role => (
          role.classes &&
          role.classes.some(classId => {
            const _class = this.classes[classId]
            return _class && _class.name && _class.name.toLowerCase().includes(lowerCaseSearch)
          })
        ))
      }

      return this.sortedUsers.filter(user => (
        matchesName(user) ||
        matchesProviderId(user) ||
        matchesInitials(user) ||
        matchesClassName(user)
      ))
    },
    teachers: function() {
      return this.sortedUsers.filter(user => {
        return user.roles.some(role => role.type === 'teacher')
      })
    },
    filteredTeachers: function() {
      return this.filteredRecipients.filter(user => {
        return user.roles.some(role => role.type === 'teacher')
      })
    },
    tutors: function() {
      return this.sortedUsers.filter(user => {
        return user.roles.some(role => role.type === 'tutor')
      })
    },
    filteredTutors: function() {
      return this.filteredRecipients.filter(user => {
        return user.roles.some(role => role.type === 'tutor')
      })
    },
    students: function() {
      return this.sortedUsers.filter(user => {
        return user.roles.some(role => role.type === 'student')
      })
    },
    filteredStudents: function() {
      return this.filteredRecipients.filter(user => {
        return user.roles.some(role => role.type === 'student')
      })
    },
    contactPersons: function() {
      return this.sortedUsers.filter(user => {
        return user.roles.some(role => role.type === 'contact_person')
      })
    },
    filteredContactPersons: function() {
      return this.filteredRecipients.filter(user => {
        return user.roles.some(role => role.type === 'contact_person')
      })
    },
    inspectors: function() {
      return this.sortedUsers.filter(user => {
        return user.roles.some(role => role.type === 'inspector')
      })
    },
    filteredInspectors: function() {
      return this.filteredRecipients.filter(user => {
        return user.roles.some(role => role.type === 'inspector')
      })
    },
    consentedUsersCount: function() {
      return this.sortedUsers.filter(user => user.is_consented).length
    },
    undecidedConsentUsersCount: function() {
      return this.sortedUsers.filter(user => !user.is_consented && user.is_changeable_consent).length
    },
    deniedConsentUserCount: function() {
      return this.sortedUsers.filter(user => !user.is_consented && !user.is_changeable_consent).length
    },
    hasNoPhoneNumberCount() {
      return this.sortedUsers.filter(user => !user.has_phone_number).length
    },
    sortedClasses() {
      return Object.values(this.classes).sort((a, b) => {
        const lowerCaseA = a.name.toLocaleLowerCase()
        const lowerCaseB = b.name.toLocaleLowerCase()
        return lowerCaseA.localeCompare(lowerCaseB)
      })
    },
    filteredClasses() {

      const lowerCaseSearch = this.classSearch.toLowerCase()
      if (lowerCaseSearch.length < 1) {
        return this.sortedClasses
      }

      return this.sortedClasses.filter(_class => {
        return _class.name && _class.name.toLowerCase().includes(lowerCaseSearch)
      })
    },
  },
}
</script>

<template>
  <div class="app">
    <error-screen
      v-if="openScreen === 'error-screen'"
      :translations='translations'
    >
    </error-screen>
    <unauthorized-screen
      v-if="openScreen === 'unauthorized-screen'"
      :translations='translations'
      :is-minimized="isMinimized"
      @maximize="maximize"
      @minimize="minimize"
    >
    </unauthorized-screen>
    <select-school-screen
      v-else-if="openScreen === 'select-school-screen'"
      :is-loading='isPerformingFirstLoad'
      :is-minimized="isMinimized"
      :is-untouched='isUntouched'
      :schools="schools"
      :shown-blacklist-reasons="shownBlacklistReasons"
      :close-blacklist-reasons-modal='closeBlacklistReasonsModal'
      :translations="translations"
      @maximize="maximize"
      @minimize="minimize"
      @select-school="school => selectSchool(school)"
    >
    </select-school-screen>
    <div v-else-if="openScreen === 'groups-overview-screen' || openScreen === 'people-overview-screen'" :class="[isMinimized && 'closed', 'main-container']">
      <div class="header">
        <div class="header-heading">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="header-icon left pointer" @click="unselectSchool">
            <path d="M20.393 5.333l0.94 0.94-8.78 9.727 8.78 9.727-0.94 0.94-9.727-10.667 9.727-10.667z" />
          </svg>
          <h3 class="header-title">{{ selectedSchool.name }}</h3>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="header-icon right pointer" v-if="isMinimized" @click="maximize">
            <path
              d="M12.193 18.827l-8.193 8.193v-6.353h-1.333v8.667h8.667v-1.333h-6.393l8.2-8.213-0.947-0.96zM20.667 2.667v1.333h6.393l-8.2 8.18 0.947 0.933 8.193-8.207v6.427h1.333v-8.667h-8.667zM11.333 4v-1.333h-8.667v8.667h1.333v-6.427l8.193 8.2 0.947-0.927-8.2-8.18h6.393zM28 26.933l-7.513-8.087-0.973 0.927 7.627 8.227h-6.473v1.333h8.667v-8.667h-1.333v6.267z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="header-icon right pointer" v-else @click="minimize">
            <path
              d="M28 10.667h-5.833l7.167-7.133-0.9-0.867-7.167 7.16 0.067-5.827h-1.267l-0.067 8h8v-1.333zM4 21.333h5.833l-7.167 7.133 0.867 0.867 7.133-7.167v5.833h1.333v-8h-8v1.333zM28 21.333v-1.333h-8v8h1.333v-5.833l7.133 7.167 0.867-0.867-7.167-7.133h5.833zM10.667 9.833l-7.133-7.167-0.867 0.867 7.167 7.133h-5.833v1.333h8v-8h-1.333v5.833z" />
          </svg>
        </div>
        <div class="header-links">
          <div class='header-links-background'>
            <div :class="[openScreen === 'groups-overview-screen' && 'header-link-active', 'header-link']" @click="navigate('groups-overview-screen')">
              <span>{{ translations.groupsOverviewScreen.toggleTitle }}</span>
            </div>
            <div :class="[openScreen === 'people-overview-screen' && 'header-link-active', 'header-link']" @click="navigate('people-overview-screen')">
              <span>{{ translations.peopleOverviewScreen.toggleTitle }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="body main-screen-content scrollable">
        <div v-if="openScreen === 'groups-overview-screen' || openScreen === 'people-overview-screen'">
          <div v-if="openScreen === 'groups-overview-screen'">

            <div v-if="allGroups.length" class="group-list-container">

              <div style='padding-top: 10px;'>
                <search
                  :placeholder='translations.groupsOverviewScreen.searchPlaceholder'
                  :search='groupSearch'
                  :search-change='setGroupSearch'
                  :search-clear='clearGroupSearch'
                >
                </search>
              </div>

              <div v-if='filteredGroups.length < 1'>
                <p style='font-size: 14px; color: #6F7785;'>{{ translations.groupsOverviewScreen.noMatchingGroups }}</p>
              </div>

              <div :key="group.id" v-for="group in sortedGroups" class="group-card pointer" @click="handleSelectGroup(group.id)">
                <div class="group-member-amount">
                  <span class='number-text'>{{ groupMembers[group.id].users.length }}</span>
                </div>
                <div class='group-text-container'>
                  <h3 class="group-heading">{{ group.name }}</h3>
                  <p class="group-excerpt" v-if='group.latest_group_message'>
                    {{ group.latest_group_message ? group.latest_group_message.text : '' }}
                  </p>
                </div>
                <p class="group-date">
                  {{ formatGroupActivityTime(group.latest_group_message ? group.latest_group_message.created_at : group.created_at) }}</p>
              </div>
            </div>
            <div v-else-if="!sortedGroups.length && isGroupsLoading">
              <spinner></spinner>
            </div>
            <div v-else>
              <div class="no-groups-container container mx-auto text-center">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 165 96.633" class="no-groups-illustration">
                  <defs>
                    <filter id="Path_709" x="34.54" y="6.326" width="57.219" height="56.113" filterUnits="userSpaceOnUse">
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="3" result="blur" />
                      <feFlood flood-opacity="0.161" />
                      <feComposite operator="in" in2="blur" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g id="Illustration" transform="translate(-0.194)">
                    <g id="Group_1856" data-name="Group 1856" transform="translate(0.194)" opacity="0.75">
                      <path id="Path_684" data-name="Path 684"
                            d="M164.106,48.564c8.968,23.959-39.779,45.957-61.662,47.832-21.821,1.968-62.355,4.729-90.026-25.955C-15.175,39.644,4.382-15.8,66.68,7.53,129.029,30.927,155.192,24.683,164.106,48.564Z"
                            transform="translate(-0.194 -0.857)" fill="#f2f5f9" fill-rule="evenodd" />
                      <image id="Rectangle_1719" data-name="Rectangle 1719" width="59.389" height="96.367" transform="translate(96.108)"
                             xlink:href="data:image/png;base64,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" />
                      <path id="Path_685" data-name="Path 685"
                            d="M67.318,124.161c-16.677-2.775-34.217-9.72-48.387-25.418a49.186,49.186,0,0,1-3.95-5.024v-27.4H67.318Z"
                            transform="translate(-6.696 -29.16)" fill="#e2eaf5" fill-rule="evenodd" />
                      <path id="Path_686" data-name="Path 686"
                            d="M28.731,75.127a4.938,4.938,0,0,1,4.938,4.937v8.271H23.794V80.064A4.937,4.937,0,0,1,28.731,75.127Z"
                            transform="translate(-10.572 -33.035)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_687" data-name="Path 687"
                            d="M28.731,110.157a4.937,4.937,0,0,1,4.938,4.937v8.27H28.078s-1.074-.986-2.159-2.053-2.028-2.121-2.028-2.121l-.1-4.1A4.937,4.937,0,0,1,28.731,110.157Z"
                            transform="translate(-10.572 -48.439)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_688" data-name="Path 688"
                            d="M57.813,75.127a4.937,4.937,0,0,1,4.937,4.937v8.271H52.875V80.064A4.937,4.937,0,0,1,57.813,75.127Z"
                            transform="translate(-23.388 -33.035)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_689" data-name="Path 689"
                            d="M57.813,110.157a4.937,4.937,0,0,1,4.937,4.937v8.27H52.875v-8.27A4.937,4.937,0,0,1,57.813,110.157Z"
                            transform="translate(-23.388 -48.439)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_690" data-name="Path 690"
                            d="M86.894,75.127a4.938,4.938,0,0,1,4.938,4.937v8.271H81.956V80.064A4.938,4.938,0,0,1,86.894,75.127Z"
                            transform="translate(-36.191 -33.035)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_691" data-name="Path 691"
                            d="M86.894,110.157a4.937,4.937,0,0,1,4.938,4.937v8.27H81.956v-8.27A4.937,4.937,0,0,1,86.894,110.157Z"
                            transform="translate(-36.191 -48.439)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_692" data-name="Path 692"
                            d="M58.2,145.187a4.937,4.937,0,0,1,4.937,4.937v2.7L58.2,150.483s-1.516-.759-4.447-2.451A4.785,4.785,0,0,1,58.2,145.187Z"
                            transform="translate(-23.774 -63.842)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_693" data-name="Path 693"
                            d="M86.894,145.187a4.937,4.937,0,0,1,4.938,4.937l.054,7.805s-3.195-.718-5.677-1.4-4.252-1.333-4.252-1.333v-5.07A4.937,4.937,0,0,1,86.894,145.187Z"
                            transform="translate(-36.191 -63.842)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_694" data-name="Path 694" d="M26,33.267H65.991V45.611H26Z" transform="translate(-11.54 -14.628)" fill="#e2eaf5"
                            fill-rule="evenodd" />
                      <path id="Path_695" data-name="Path 695" d="M29.3,36.572h36.29v8.641H29.3Z" transform="translate(-12.994 -16.082)" fill="#fff"
                            fill-rule="evenodd" />
                      <path id="Path_696" data-name="Path 696" d="M38.687,55.3H37.453V61.47h1.234Z" transform="translate(-16.578 -24.316)"
                            fill="#e2eaf5" />
                      <path id="Path_697" data-name="Path 697" d="M84.953,55.3H83.719V61.47h1.234Z" transform="translate(-36.965 -24.316)"
                            fill="#e2eaf5" />
                      <path id="Path_698" data-name="Path 698"
                            d="M156.534,124.218a56.486,56.486,0,0,1-6.419.964c-10.667.961-25.8,2.112-41.721-.537V85.931l24.07-18.515,24.07,18.515Z"
                            transform="translate(-47.851 -29.645)" fill="#d3e0f1" fill-rule="evenodd" />
                      <path id="Path_699" data-name="Path 699"
                            d="M117.577,107.293h8.641a.37.37,0,0,1,.37.37V116.3a.37.37,0,0,1-.37.37h-8.641a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,117.577,107.293Z"
                            transform="translate(-51.711 -47.179)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_700" data-name="Path 700"
                            d="M143.353,107.293h8.641a.37.37,0,0,1,.37.37V116.3a.37.37,0,0,1-.37.37h-8.641a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,143.353,107.293Z"
                            transform="translate(-63.059 -47.179)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_701" data-name="Path 701"
                            d="M169.13,107.293h8.641a.37.37,0,0,1,.37.37V116.3a.37.37,0,0,1-.37.37H169.13a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,169.13,107.293Z"
                            transform="translate(-74.408 -47.179)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_702" data-name="Path 702"
                            d="M117.577,128.443h8.641a.37.37,0,0,1,.37.37v8.641a.37.37,0,0,1-.37.37h-8.641a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,117.577,128.443Z"
                            transform="translate(-51.711 -56.48)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_703" data-name="Path 703"
                            d="M143.353,128.443h8.641a.37.37,0,0,1,.37.37v8.641a.37.37,0,0,1-.37.37h-8.641a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,143.353,128.443Z"
                            transform="translate(-63.059 -56.48)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_704" data-name="Path 704"
                            d="M169.13,128.443h8.641a.37.37,0,0,1,.37.37v8.641a.37.37,0,0,1-.37.37H169.13a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,169.13,128.443Z"
                            transform="translate(-74.408 -56.48)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_705" data-name="Path 705"
                            d="M117.577,149.593h8.641a.37.37,0,0,1,.37.37V158.6a.37.37,0,0,1-.37.37h-8.641a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,117.577,149.593Z"
                            transform="translate(-51.711 -65.78)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_706" data-name="Path 706"
                            d="M143.353,149.593h8.641a.37.37,0,0,1,.37.37V158.6a.37.37,0,0,1-.37.37h-8.641a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,143.353,149.593Z"
                            transform="translate(-63.059 -65.78)" fill="#fff" fill-rule="evenodd" />
                      <path id="Path_707" data-name="Path 707"
                            d="M169.13,149.593h8.641a.37.37,0,0,1,.37.37V158.6a.37.37,0,0,1-.37.37H169.13a.37.37,0,0,1-.37-.37v-8.641A.37.37,0,0,1,169.13,149.593Z"
                            transform="translate(-74.408 -65.78)" fill="#fff" fill-rule="evenodd" />
                    </g>
                    <path id="Path_708" data-name="Path 708"
                          d="M124.766,39.5h35.3a11.766,11.766,0,0,1,11.766,11.766v25a11.766,11.766,0,0,1-11.766,11.766H127.9l-10.132,8A2.941,2.941,0,0,1,113,93.728V51.266A11.766,11.766,0,0,1,124.766,39.5Z"
                          transform="translate(-49.693 -17.369)" fill="#8c94a6" />
                    <g transform="matrix(1, 0, 0, 1, 0.19, 0)" filter="url(#Path_709)">
                      <path id="Path_709-2" data-name="Path 709"
                            d="M109.375,22H85.844A7.844,7.844,0,0,0,78,29.844V46.512a7.844,7.844,0,0,0,7.844,7.844h21.445l6.755,5.335a1.961,1.961,0,0,0,3.176-1.539V29.844A7.844,7.844,0,0,0,109.375,22Z"
                            transform="translate(-34.46 -9.67)" fill="#8c94a6" />
                    </g>
                  </g>
                </svg>
                <h3 class="no-groups-heading">
                  {{ translations.groupsOverviewScreen.noGroupsHeading }}
                </h3>
                <p class="no-groups-text">
                  {{ translations.groupsOverviewScreen.noGroupsText }}
                </p>
              </div>
            </div>
          </div>
          <div v-else-if="openScreen === 'people-overview-screen'">
            <div class="people">
              <div class="people-padding">
                <search
                  :placeholder="translations.peopleOverviewScreen.peopleSearchPlaceholder"
                  :search="recipientSearch"
                  :search-clear='clearRecipientSearch'
                  :search-change='setRecipientSearch'
                >
                </search>
                <consent-box
                  v-if="giveConsentUsers.length > 0"
                  :sub-header-text="anySelectedRecipients ? translations.peopleOverviewScreen.consentBoxSubheaderSelectedRecipients : translations.peopleOverviewScreen.consentBoxSubheaderPeople"
                  :users="giveConsentUsers"
                  :give-consent="() => giveConsent(giveConsentUsers)"
                  :translations='translations'
                >
                </consent-box>
                <div class="recipient-information">
                  <div class="recipient-amount-description number-text">
                    {{ interpolate(translations.peopleOverviewScreen.amountDescription, { count: filteredRecipients.length }) }}
                  </div>

                  <div class='recipient-status-icon-container' @mouseenter='openPeopleStatusesOverlay' @mouseleave='closePeopleStatusesOverlay'>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="recipient-status-main-icon fill-blue">
                      <path
                        d="M12.667 5.333h16.667v1.333h-16.667v-1.333zM12.667 15.333h16.667v1.333h-16.667v-1.333zM12.667 25.333h16.667v1.333h-16.667v-1.333zM6 2.667c-1.841 0-3.333 1.492-3.333 3.333s1.492 3.333 3.333 3.333c1.841 0 3.333-1.492 3.333-3.333v0c0-1.841-1.492-3.333-3.333-3.333v0zM6 8c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c0 1.105-0.895 2-2 2v0zM6 12.667c-1.841 0-3.333 1.492-3.333 3.333s1.492 3.333 3.333 3.333c1.841 0 3.333-1.492 3.333-3.333v0c0-1.841-1.492-3.333-3.333-3.333v0zM6 18c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c0 1.105-0.895 2-2 2v0zM6 22.667c-1.841 0-3.333 1.492-3.333 3.333s1.492 3.333 3.333 3.333c1.841 0 3.333-1.492 3.333-3.333v0c0-1.841-1.492-3.333-3.333-3.333v0zM6 28c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c0 1.105-0.895 2-2 2v0z" />
                    </svg>
                    <div class='recipient-status-overlay-container' v-if='isPeopleStatusesOverlayOpen'>
                      <div class='recipient-status-overlay-item'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="recipient-status-overlay-icon fill-blue">
                          <path
                            d="M4 0v32h15.333c4.786 0 8.667-3.88 8.667-8.667v0-23.333h-24zM26.667 23.333c0 4.050-3.283 7.333-7.333 7.333v0h-14v-29.333h21.333v22zM10.667 9.333h10.667v1.333h-10.667v-1.333zM10.667 14.667h10.667v1.333h-10.667v-1.333zM10.667 20h8v1.333h-8v-1.333z" />
                        </svg>
                        <p class="recipient-status-overlay-text">{{ translations.peopleOverviewScreen.consentGiven }}</p>
                        <p class="recipient-status-overlay-number number-text">{{ consentedUsersCount }}</p>
                      </div>
                      <div class='recipient-status-overlay-item'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="recipient-status-overlay-icon fill-orange">
                          <path
                            d="M10.667 14.679v1.333h10.667v-1.333h-10.667zM18.667 20.012v1.333h-8v-1.333h8zM10.667 9.346v1.333h10.667v-1.333h-10.667zM19.333 30.667l-14 0.012v-29.333h21.333v15.988c0.529 0 0.863 0 1.333 0v-17.321h-24v32l15.333-0.012v-1.333zM26.171 21.333l-0.179 5.254-0.008 0.242v0.004h-1.308l-0.183-5.5zM26.212 28.504c0 0.1-0.012 0.196-0.042 0.283 0 0 0 0 0 0-0.038 0.117-0.104 0.221-0.2 0.313-0.050 0.050-0.108 0.092-0.171 0.125-0.133 0.075-0.292 0.108-0.471 0.108-0.121 0-0.229-0.017-0.329-0.050-0.117-0.038-0.217-0.1-0.304-0.183-0.121-0.117-0.196-0.254-0.225-0.413-0.012-0.058-0.017-0.117-0.017-0.179 0-0.242 0.079-0.438 0.242-0.596s0.375-0.238 0.633-0.238h0.012c0.258 0.004 0.471 0.079 0.629 0.233 0.133 0.129 0.212 0.288 0.233 0.475 0.008 0.038 0.008 0.079 0.008 0.121zM25.333 20c1.425 0 2.762 0.554 3.771 1.563s1.563 2.346 1.563 3.771-0.554 2.762-1.563 3.771-2.346 1.563-3.771 1.563-2.762-0.554-3.771-1.563c-1.008-1.008-1.563-2.346-1.563-3.771s0.554-2.762 1.563-3.771c1.008-1.008 2.346-1.563 3.771-1.563zM25.333 18.667c-3.683 0-6.667 2.983-6.667 6.667s2.983 6.667 6.667 6.667 6.667-2.983 6.667-6.667-2.983-6.667-6.667-6.667v0z" />
                        </svg>
                        <p class="recipient-status-overlay-text">{{ translations.peopleOverviewScreen.consentUndecided }}</p>
                        <p class="recipient-status-overlay-number number-text">{{ undecidedConsentUsersCount }}</p>
                      </div>
                      <div class='recipient-status-overlay-item'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="recipient-status-overlay-icon fill-red">
                          <path
                            d="M10.667 14.679v1.333h10.667v-1.333h-10.667zM18.667 20.012v1.333h-8v-1.333h8zM10.667 9.346v1.333h10.667v-1.333h-10.667zM19.333 30.667l-14 0.012v-29.333h21.333v15.988c0.529 0 0.863 0 1.333 0v-17.321h-24v32l15.333-0.012v-1.333zM26.171 21.333l-0.179 5.254-0.008 0.242v0.004h-1.308l-0.183-5.5zM26.212 28.504c0 0.1-0.012 0.196-0.042 0.283 0 0 0 0 0 0-0.038 0.117-0.104 0.221-0.2 0.313-0.050 0.050-0.108 0.092-0.171 0.125-0.133 0.075-0.292 0.108-0.471 0.108-0.121 0-0.229-0.017-0.329-0.050-0.117-0.038-0.217-0.1-0.304-0.183-0.121-0.117-0.196-0.254-0.225-0.413-0.012-0.058-0.017-0.117-0.017-0.179 0-0.242 0.079-0.438 0.242-0.596s0.375-0.238 0.633-0.238h0.012c0.258 0.004 0.471 0.079 0.629 0.233 0.133 0.129 0.212 0.288 0.233 0.475 0.008 0.038 0.008 0.079 0.008 0.121zM25.333 20c1.425 0 2.762 0.554 3.771 1.563s1.563 2.346 1.563 3.771-0.554 2.762-1.563 3.771-2.346 1.563-3.771 1.563-2.762-0.554-3.771-1.563c-1.008-1.008-1.563-2.346-1.563-3.771s0.554-2.762 1.563-3.771c1.008-1.008 2.346-1.563 3.771-1.563zM25.333 18.667c-3.683 0-6.667 2.983-6.667 6.667s2.983 6.667 6.667 6.667 6.667-2.983 6.667-6.667-2.983-6.667-6.667-6.667v0z" />
                        </svg>
                        <p class="recipient-status-overlay-text">{{ translations.peopleOverviewScreen.consentNotGiven }}</p>
                        <p class="recipient-status-overlay-number number-text">{{ deniedConsentUserCount }}</p>
                      </div>
                      <div class='recipient-status-overlay-item'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="recipient-status-overlay-icon fill-red">
                          <path
                            d="M22 0h-12c-1.841 0-3.333 1.492-3.333 3.333v0 25.333c0 1.841 1.492 3.333 3.333 3.333v0h12c1.841 0 3.333-1.492 3.333-3.333v0-25.333c0-1.841-1.492-3.333-3.333-3.333v0zM10 1.333h12c1.105 0 2 0.895 2 2v0 22h-16v-22c0-1.105 0.895-2 2-2v0zM22 30.667h-12c-1.105 0-2-0.895-2-2v0-2h16v2c0 1.105-0.895 2-2 2v0zM17.333 28.667c0 0.736-0.597 1.333-1.333 1.333s-1.333-0.597-1.333-1.333c0-0.736 0.597-1.333 1.333-1.333s1.333 0.597 1.333 1.333z" />
                        </svg>
                        <p class="recipient-status-overlay-text">{{ translations.peopleOverviewScreen.missingPhone }}</p>
                        <p class="recipient-status-overlay-number number-text">{{ hasNoPhoneNumberCount }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <recipient-type
                role="teacher"
                :translations='translations'
                :header="translations.general.roles.teachers"
                :recipients="filteredTeachers"
                :is-selectable='false'
                :selected-users="selected.users"
                :keyed-classes='this.classes'
                :give-consent='giveConsent'
                @add-recipient="recipient => selectRecipient(recipient)"
                @remove-recipient="recipient => unSelectRecipient(recipient)"
              >
              </recipient-type>
              <recipient-type
                role="tutor"
                :translations='translations'
                :header="translations.general.roles.tutors"
                :recipients="filteredTutors"
                :is-selectable='false'
                :selected-users="selected.users"
                :keyed-classes='this.classes'
                :give-consent='giveConsent'
                @add-recipient="recipient => selectRecipient(recipient)"
                @remove-recipient="recipient => unSelectRecipient(recipient)"
              >
              </recipient-type>
              <recipient-type
                role="student"
                :translations='translations'
                :header="translations.general.roles.students"
                :recipients="filteredStudents"
                :is-selectable='false'
                :selected-users="selected.users"
                :keyed-classes='this.classes'
                :give-consent='giveConsent'
                @add-recipient="recipient => selectRecipient(recipient)"
                @remove-recipient="recipient => unSelectRecipient(recipient)"
              >
              </recipient-type>
              <recipient-type
                role="contact_person"
                :translations='translations'
                :header="translations.general.roles.contacts"
                :recipients="filteredContactPersons"
                :is-selectable='false'
                :selected-users="selected.users"
                :keyed-classes='this.classes'
                :give-consent='giveConsent'
                @add-recipient="recipient => selectRecipient(recipient)"
                @remove-recipient="recipient => unSelectRecipient(recipient)"
              >
              </recipient-type>
              <recipient-type
                role="inspector"
                :translations='translations'
                :header="translations.general.roles.inspectors"
                :recipients="filteredInspectors"
                :is-selectable='false'
                :selected-users="selected.users"
                :keyed-classes='this.classes'
                :give-consent='giveConsent'
                @add-recipient="recipient => selectRecipient(recipient)"
                @remove-recipient="recipient => unSelectRecipient(recipient)"
              >
              </recipient-type>
            </div>
          </div>
        </div>
        <div @click="navigate('new-group-message-screen')" :class="[isMinimized && 'closed', 'new-message-button']">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32" class="new-message-icon">
            <path
              d="M0.667 0v32l10.24-9.333h13.093c4.050 0 7.333-3.283 7.333-7.333v0-15.333h-30.667zM30 15.333c0 3.314-2.686 6-6 6v0h-13.587l-8.413 7.88v-27.88h28v14zM10 11.333c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2zM18 11.333c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2zM26 11.333c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z" />
          </svg>
        </div>
      </div>
    </div>
    <div v-else-if="openScreen === 'group-messages-screen' || openScreen === 'group-members-screen'" class="group-messages-container">
      <div class="modal-background" v-if="isNewMessageConfirmModalOpen">
        <confirm-send-message-modal
          @close-modal="closeNewMessageConfirmModal"
          @send-message="closeNewMessageConfirmModal(); sendMessageToExistingGroup(selectedGroup.id)"
          :messages-amount="newMessageMessagesAmount"
          :recipients-receivable='selectedGroupMembers.usersReceivable'
          :recipients-not-receivable='selectedGroupMembers.usersNotReceivable'
          :recipients-without-consent='selectedGroupMembers.usersNotConsented'
          :recipients-without-phone='selectedGroupMembers.usersNoPhoneNumber'
          :translations='translations'
        >
        </confirm-send-message-modal>
      </div>
      <div class="modal-background" v-if="isNewMessageErrorModalOpen">
        <message-validation-errors-modal
          :errors='newMessageErrors'
          :translations='translations'
          :on-close="closeNewMessageErrorModal"
        >
        </message-validation-errors-modal>
      </div>
      <div class="header">
        <div class="header-heading">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="header-icon left pointer"
               @click="openScreen !== 'group-members-screen' ? handleCloseNewGroupMessageScreen() : navigate('group-messages-screen')">
            <path d="M20.393 5.333l0.94 0.94-8.78 9.727 8.78 9.727-0.94 0.94-9.727-10.667 9.727-10.667z" />
          </svg>
          <div @click="navigate('group-members-screen')" class='pointer'>
            <h3
              :class="[openScreen !== 'group-members-screen' && 'text-underline', 'header-title']">
              {{ selectedGroup.name }}
            </h3>
            <p class='header-tagline' v-if="openScreen !== 'group-members-screen'">
              <span class='number-text'>{{ selectedGroupMembers.users.length }}</span> {{ translations.groupMessagesScreen.members }}
            </p>
          </div>
        </div>
      </div>
      <div class="modal-background" v-if="isConfirmBackModalOpen">
        <confirm-back-modal
          :on-close="closeConfirmBackModal"
          :on-confirm="closeNewGroupMessageScreen"
          :translations='translations'
        >
        </confirm-back-modal>
      </div>
      <group-messages-screen
        v-if="openScreen === 'group-messages-screen'"
        :sorted-selected-group-messages="sortedSelectedGroupMessages"
        :new-message="newMessage"
        :new-message-length-description="newMessageLengthDescription"
        :new-message-messages-amount="newMessageMessagesAmount"
        :characters-in-current-message="charactersInCurrentMessage"
        :is-new-message-loading="isNewMessageLoading"
        :handle-new-message-change="handleNewMessageChange"
        :attempt-send-message-to-existing-group="attemptSendMessageToExistingGroup"
        :handle-open-message-recipients-screen="handleOpenMessageRecipientsScreen"
        :translations="translations"
        :is-valid-gsm-message='isValidGsmMessage'
        :selected-group="selectedGroup">

      </group-messages-screen>
      <group-members-screen
        v-if="openScreen === 'group-members-screen'"
        :members='selectedGroup.members'
        :classes='this.classes'
        :users='this.users'
        :selected-group-members-filtered="selectedGroupMembersFiltered"
        :selected-group-members-where-consentable="selectedGroupMembersWhereConsentable"
        :selected="selected"
        :recipient-search="recipientSearch"
        :clear-recipient-search='clearRecipientSearch'
        :set-recipient-search='setRecipientSearch'
        :give-consent="giveConsent"
        :translations="translations"
      ></group-members-screen>
    </div>
    <message-recipients-screen
      :recipient-search="recipientSearch"
      :clear-recipient-search="clearRecipientSearch"
      :set-recipient-search="setRecipientSearch"
      :selected-message-statuses="selectedMessageStatuses"
      :selected-message-status-filters="selectedMessageStatusFilters"
      :selected-message-recipients-length="selectedMessageRecipientsLength"
      :selected="selected"
      :selected-message-recipients-filtered="selectedMessageRecipientsFiltered"
      :add-status-filter="addStatusFilter"
      :remove-status-filter="removeStatusFilter"
      :navigate="navigate"
      :translations="translations"
      :keyed-classes='this.classes'
      v-else-if="openScreen === 'message-recipients-screen'"
    >
    </message-recipients-screen>
    <new-group-message-screen
      v-else-if="openScreen === 'new-group-message-screen'"
      :is-new-message-confirm-modal-open="isNewMessageConfirmModalOpen"
      :is-new-message-error-modal-open="isNewMessageErrorModalOpen"
      :new-message-messages-amount="newMessageMessagesAmount"
      :is-new-message-loading="isNewMessageLoading"
      :selected-recipients="selectedRecipients"
      :un-select-recipient='unSelectRecipient'
      :un-select-all-group-type='unSelectAllGroupType'
      :un-select-all-group-type-by-class='unSelectAllGroupTypeByClass'
      :new-message="newMessage"
      :on-message-change='handleNewMessageChange'
      :new-message-length-description="newMessageLengthDescription"
      :characters-in-current-message="charactersInCurrentMessage"
      :selected="selected"
      :any-selected-recipients='anySelectedRecipients'
      :new-message-errors="newMessageErrors"
      :selected-recipients-receivable="selectedRecipientsReceivable"
      :selected-recipients-without-consent="selectedRecipientsWithoutConsent"
      :selected-recipients-without-phone="selectedRecipientsWithoutPhone"
      :selected-recipients-not-receivable="selectedRecipientsNotReceivable"
      :close-new-message-confirm-modal="closeNewMessageConfirmModal"
      :is-valid-gsm-message='isValidGsmMessage'
      :handle-send-message="handleSendMessage"
      :new-message-group-name="newMessageGroupName"
      :translations="translations"
      :is-confirm-back-modal-open="isConfirmBackModalOpen"
      :close-confirm-back-modal="closeConfirmBackModal"
      :confirm-go-back='closeNewGroupMessageScreen'
      :is-removed-selected-recipients-not-empty="isRemovedSelectedRecipientsNotEmpty"
      :undo-remove-selected-recipients="undoRemoveSelectedRecipients"
      @handle-message-change="text => handleNewMessageChange(text)"
      :handle-message-group-name-change='text => handleNewMessageGroupNameChange(text)'
      @unselect-recipient="recipient => selectRecipient(recipient)"
      @unselect-all-recipients="removeSelectedRecipients"
      :attempt-send-message="attemptSendMessage"
      @open-select-recipients-screen="navigate('select-recipients-screen')"
      @handle-close="handleCloseNewGroupMessageScreen"
      @close-new-message-error-modal="closeNewMessageErrorModal">
    </new-group-message-screen>
    <select-recipients-screen
      v-else-if="openScreen === 'select-recipients-screen'"
      :select-recipients-mode="selectRecipientsMode"
      :selected="selected"
      :selected-recipients="selectedRecipients"
      :teachers="teachers"
      :recipient-search="recipientSearch"
      :filtered-recipients='filteredRecipients'
      :set-recipient-search="setRecipientSearch"
      :clear-recipient-search="clearRecipientSearch"
      :set-recipients-Search="setRecipientSearch"
      :un-select-recipient="unSelectRecipient"
      :remove-selected-recipients="removeSelectedRecipients"
      :give-consent-users="giveConsentUsers"
      :filtered-teachers="filteredTeachers"
      :filtered-tutors="filteredTutors"
      :filtered-students="filteredStudents"
      :filtered-contact-persons="filteredContactPersons"
      :filtered-inspectors="filteredInspectors"
      :give-consent="giveConsent"
      :is-removed-selected-recipients-not-empty="isRemovedSelectedRecipientsNotEmpty"
      :any-selected-recipients="anySelectedRecipients"
      :class-search="classSearch"
      :clear-class-search="clearClassSearch"
      :set-slass-search="setClassSearch"
      :filtered-classes="filteredClasses"
      :keyed-classes="classes"
      :select-all-group-type-by-class="selectAllGroupTypeByClass"
      :un-select-all-group-type-by-class="unSelectAllGroupTypeByClass"
      :un-select-all-group-type="unSelectAllGroupType"
      :set-class-search="setClassSearch"
      :translations="translations"
      :undo-remove-selected-recipients="undoRemoveSelectedRecipients"
      @select-recipients-by-people="selectRecipientsByPeople"
      @select-recipients-by-group="selectRecipientsByGroup"
      @select-all-group-type="groupType => selectAllGroupType(groupType)"
      @un-select-all-group-type="groupType => unSelectAllGroupType(groupType)"
      @select-recipient="recipient => selectRecipient(recipient)"
      @close-select-recipients-screen="navigate('new-group-message-screen')"
    >
    </select-recipients-screen>
    <message-success-screen
      v-else-if="openScreen === 'new-group-message-success-screen'"
      :translations='translations'
      @open-groups-overview-screen="navigate('groups-overview-screen')">
    </message-success-screen>
    <widget-footer></widget-footer>
  </div>
</template>

<style scoped>

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes minimize {
  0% {
    height: 380px;
  }
  100% {
    height: 0;
  }
}

@keyframes maximize {
  0% {
    height: 0;
    overflow: hidden;
  }
  90% {
    overflow: hidden;
  }
  100% {
    height: 380px;
  }
}

/** NC Added */
.app ::v-deep  input[type="text"],
.app ::v-deep  input[type="url"],
.app ::v-deep  input[type="date"],
.app ::v-deep  input[type="week"],
.app ::v-deep  select,
.app ::v-deep  textarea {
  display: block;
  width: 100%;
  font-size: 1rem;
  line-height: 1;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  touch-action: manipulation;
  border: 1px solid #d9e3e9;
  border-radius: 5px;
  color: #222350;
  padding: 10px;
  outline: 0;
  margin-top: 2px;
  margin-bottom: 10px;
  font-size: 12px;
}

/** NC Added */
.app ::v-deep  textarea {
  resize: none;
}

/** NC Added */
.app ::v-deep  input[type="checkbox"] {
  position: relative;
  top: 2px;
}

.app {
  position: relative;
  background: #fff;
  height: 100%;
}

.app ::v-deep  * {
  font-family: Helvetica, Arial, sans-serif;
  margin: 0;
  padding: 0;
  border: 0;
  text-align: left;
}

.app ::v-deep  :not(strong) {
  font-weight: 400;
}

.app ::v-deep  .number-text {
  font-family: Lato, Arial, sans-serif;
}

.app ::v-deep  .text-color-primary {
  color: #222350;
}

.app ::v-deep  .text-color-lighter {
  color: #555;;
}

.app ::v-deep  .scrollable {
  overflow-y: auto;
  overflow-x: hidden;
}

.app ::v-deep  .scrollable::-webkit-scrollbar {
  width: 14px;
  height: 18px;
}

.app ::v-deep  .scrollable::-webkit-scrollbar-track {
  background: transparent;
}

.app ::v-deep  .scrollable::-webkit-scrollbar-thumb {
  height: 6px;
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  -webkit-border-radius: 7px;
  background-color: rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: inset;
  overflow-y: auto;
}

.app ::v-deep  label {
  text-transform: none;
}

.app ::v-deep  .loader-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.app ::v-deep  .loader-spinner {
  animation: spin 4s infinite linear;;
}

.app ::v-deep  .error-message-screen {
  width: 100%;
  height: 420px;
  background: #fff;
}

.app ::v-deep  .error-message-padding-container {
  padding: 15px;
  max-width: 280px;
  margin: 0 auto;
}

.app ::v-deep  .unauthorized-screen-container {
  overflow-y: auto;
  height: 100%;
}

.app ::v-deep  .unauthorized-screen-container.open {
  height: 380px;
  animation: maximize 0.5s;
}

.app ::v-deep  .unauthorized-screen-container.closed {
  height: 0;
  animation: minimize 0.5s;
  overflow: hidden;
}

.app ::v-deep  .unauthorized-screen-content {
  padding: 15px;
}

.app ::v-deep  .unauthorized-screen-bullets {
  list-style: none;
  padding-left: 15px;
  margin: 0;
}

.app ::v-deep  .unauthorized-screen-container .unauthorized-screen-bullets li {
  padding-left: 1em;
  text-indent: -.7em;
  margin-bottom: 10px;
}

.app ::v-deep  .unauthorized-screen-bullets li::before {
  content: "✱";
  padding-right: 7px;
  color: #4b84f8;
  display: inline-block;
}

.app ::v-deep  .unauthorized-screen-contact-box {
  width: 100%;
  padding: 15px;
  background: #ecf3ff;
  border-radius: 4px;
  box-sizing: border-box;
}

.app ::v-deep  .select-school-content {
  overflow-y: auto;
  height: 100%;
  padding: 0 15px 15px 15px;
}

.app ::v-deep  .select-school-container.untouched {
  display: none;
}

.app ::v-deep  .select-school-container.open {
  height: 380px;
  animation: maximize 0.5s;
}

.app ::v-deep  .select-school-container.closed {
  height: 0;
  animation: minimize 0.5s;
  overflow: hidden;
}

.app ::v-deep  .select-school-image {
  height: 100px;
  margin: 16px auto;
  display: block;
}

.app ::v-deep  .select-school-heading {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

.app ::v-deep  .select-school-tagline {
  color: #6F7785;
  padding-bottom: 16px;
  font-size: 14px;
}

.app ::v-deep  .select-school-button {
  height: 35px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #E6E7ED;
  border-radius: 5px;
  font-size: 14px;
  color: #1A2742;
}

.app ::v-deep  .select-school-button.disabled {
  color: #9c9d9e;
  background: #f5f5f5;
  cursor: not-allowed;
}

.app ::v-deep  .select-school-button:not(:last-child) {
  margin-bottom: 16px;
}

.app ::v-deep  .main-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.app ::v-deep  .header {
  width: 100%;
  background: #4487fd;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  z-index: 500;
  padding: 15px;
  box-sizing: border-box;
}

.app ::v-deep  .header .header-heading {
  display: flex;
  align-items: center;
}

.app ::v-deep  .header.header-alert {
  background: #E74D5F !important;
}

.app ::v-deep  .header.open {
  height: 98px;
}

.app ::v-deep  .header.closed {
  height: 50px;
  overflow: hidden;
}

.app ::v-deep  .header .header-icon {
  fill: #FFF;
  height: 16px;
}

.app ::v-deep  .header .help-icon {
  height: 16px;
  margin-left: auto;
}

.app ::v-deep  .header .header-icon.left {
  padding-right: 8px;
}

.app ::v-deep  .header .header-icon.right {
  margin-left: auto;
}

.app ::v-deep  .header .header-title {
  font-size: 15px;
  color: #FFF;
  text-align: left;
}

.app ::v-deep  .header .header-tagline {
  font-size: 13px;
  color: #fff;
  text-align: left;
}

.app ::v-deep  .header-links {
  padding-top: 15px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
}

.app ::v-deep  .header-links-background {
  display: inline-block;
  background: #4182f2;
  overflow: auto;
  border-radius: 8px;
}

.app ::v-deep  .header-link {
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  float: left;
  min-width: 100px;
  text-align: center;
}

.app ::v-deep  .header-link-active {
  background: #3E7BE6;
  font-weight: bold;
}

.app ::v-deep  .header-link:not(.header-link-active) {
  opacity: 0.8;
}

.app ::v-deep  .header-links .header-link span {
  font-size: 14px;
  font-weight: 300;
  color: #FFF;
}

.app ::v-deep  .main-container .body {
  background: #FFF;
  z-index: 499;
  overflow-y: auto;
}

.app ::v-deep  .main-container.closed {
  overflow: hidden;
  max-height: 50px !important;
}

.app ::v-deep  .no-groups-container {
  background: #FFF;
}

.app ::v-deep  .no-groups-illustration {
  height: 105px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.app ::v-deep  .no-groups-heading {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

.app ::v-deep  .no-groups-text {
  color: #6F7785;
  font-size: 14px;
  text-align: center;
}

.app ::v-deep  .group-list-container {
  padding: 0 12px 0 12px;
}

.app ::v-deep  .group-list-container .group-card {
  height: 55px;
  display: flex;
  width: 100%;
  align-content: flex-start;
  position: relative;
  margin-top: 12px;
}

.app ::v-deep  .group-list-container .group-text-container {
  margin: 0 15px;
  flex-grow: 1;
}

.app ::v-deep  .group-list-container .group-card:not(:last-child) {
  border-bottom: 2px solid #F2F3F6;
}

.app ::v-deep  .group-list-container .group-member-amount {
  background: #E1E4EC;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  flex-shrink: 0;
}

.app ::v-deep  .group-list-container .group-heading {
  font-size: 14px;
}

.app ::v-deep  .group-list-container .group-date {
  font-size: 10px;
  color: #959BA5;
}

.app ::v-deep  .group-list-container .group-excerpt {
  font-size: 12px;
  color: #6F7785;
  max-height: 16px;
  overflow: hidden;
  font-style: italic;
}

.app ::v-deep  .new-message-button {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background: #3E7BE6;
  position: absolute;
  bottom: 18px;
  right: 18px;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
}

.app ::v-deep  .new-message-button.closed {
  display: none;
}

.app ::v-deep  .new-message-icon {
  fill: #fff;
  height: 25px;
}

.app ::v-deep  .people {
  padding-top: 15px;
}

.app ::v-deep  .people-padding {
  padding: 0 15px;
}

.app ::v-deep  .recipient-information {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 15px;
  padding-bottom: 15px;
}

.app ::v-deep  .recipient-amount-description {
  font-size: 15px;
}

.app ::v-deep  .recipient-status-icon-container {
  position: relative;
}

.app ::v-deep  .recipient-status-main-icon {
  height: 16px;
  width: 16px;
}

.app ::v-deep  .recipient-status-overlay-container {
  padding: 15px;
  position: absolute;
  border-radius: 5px;
  background: #fff;
  top: 30px;
  right: 0;
  border: 1px solid #ddd;
  z-index: 100;
  display: flex;
  flex-direction: column;
  width: 220px;
}

.app ::v-deep  .recipient-status-overlay-item {
  display: flex;
  align-items: center;
}

.app ::v-deep  .recipient-status-overlay-item:not(:last-of-type) {
  margin-bottom: 15px;
}

.app ::v-deep  .recipient-status-overlay-icon {
  height: 16px;
  width: 16px;
}

.app ::v-deep  .recipient-status-overlay-text {
  flex-grow: 1;
  padding: 0 10px;
  font-size: 12px;
}

.app ::v-deep  .recipient-status-overlay-number {
  font-size: 12px;
}

.app ::v-deep  .recipient-list-item {
  display: flex;
  align-items: center;
  padding: 10px;
  position: relative;
}

.app ::v-deep  .recipient-initials {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background: #E1E4EC;

  display: flex;
  align-items: center;
  justify-content: center;
}

.app ::v-deep  .next-page {
  padding: 13px 15px;
  font-size: 13px;
  cursor: pointer;
}

.app ::v-deep  .recipient-initials span {
  font-size: 12px;
}

.app ::v-deep  .recipient-name {
  margin-left: 8px;
  font-size: 13px;
}

.app ::v-deep  .recipient-right-icons {
  display: flex;
  margin-left: auto;
  padding-left: 10px;
}

.app ::v-deep  .recipient-icon-container {
  margin-left: 10px;
  position: relative;
}

.app ::v-deep  .recipient-icon {
  height: 16px;
  fill: #8C94A6;
}

.app ::v-deep  .recipient-details-container {
  padding: 10px 15px;
}

.app ::v-deep  .recipient-details-item {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 7px;
}

.app ::v-deep  .recipient-details-item-value {
  color: #8C94A6;
}

.app ::v-deep  .recipient-border-bottom {
  border-bottom: 1px solid #E9EAEF;
}

.app ::v-deep  .tooltip-container {
  background: #303C55;
  padding: 5px;
  position: absolute;
  border-radius: 5px;
  color: #FFF;
  font-size: 11px;
  z-index: 10000;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  word-wrap: break-word;
}

.app ::v-deep  .tooltip-left {
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
}

.app ::v-deep  .tooltip-bottom {
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
}

.app ::v-deep  .tooltip-section {
  display: block;
  padding-top: 10px;
}

.app ::v-deep  .message-delivery-status-tooltip {
  width: 145px;
}

.app ::v-deep  .message-length-description-tooltip {
  width: 150px;
  right: -10px;
  bottom: 25px;
}

.app ::v-deep  .recipient-no-phone-tooltip, .app ::v-deep  .recipient-status-tooltip {
  width: 145px;
}

.app ::v-deep  .recipient-consent-tooltip {
  width: 100px;
}

.app ::v-deep  .give-consent-card {
  padding: 10px;
}

.app ::v-deep  .give-consent-card .consent-button {
  display: block;
  font-size: 13px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  border-radius: 10px;
  padding: 8px 10px;
}

.app ::v-deep  .give-consent-card .consent-button:hover {
  background: #007bff;
  color: #fff !important;
}

.app ::v-deep  .group-messages-container {
  background: #FFF;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.app ::v-deep  .group-messages-container .header {
  box-shadow: 0 1px 20px -10px #ffffff;
  -webkit-box-shadow: 0 1px 20px -10px #ffffff;
}

.app ::v-deep  .group-messages-container .group-date {
  color: #9399A4;
  font-size: 12px;
  padding: 18px 0;
}

.app ::v-deep  .main-screen-content {
  height: 380px;
}

.app ::v-deep  .group-messages-screen {
  display: flex;
  flex-direction: column;
}

.app ::v-deep  .group-messages-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 15px;
}

.app ::v-deep  .group-messages-form-box {
  background: #fff;
  width: 100%;
  padding: 10px;
}

.app ::v-deep  .message-container {
  padding: 15px 0;
}

.app ::v-deep  .message-container-header {
  cursor: pointer;
}

.app ::v-deep  .message-time {
  font-size: 12px;
  color: #6F7785;
  margin-bottom: 10px;
}

.app ::v-deep  .message-delivery-status-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  position: relative;
}

.app ::v-deep  .message-delivery-status-item {
  display: flex;
  align-items: center;
  margin: 0 4px;
  position: relative;
}

.app ::v-deep  .message-delivery-status-icon {
  height: 14px;
}

.app ::v-deep  .message-delivery-status-number {
  font-size: 12px;
  margin-left: 6px;
}

.app ::v-deep  .message-bubble {
  min-height: 40px;
  background: #4487fd;
  padding: 15px 15px 10px 15px;
  border-radius: 8px 8px 0 8px;
}

.app ::v-deep  .message-text {
  font-size: 13px;
  color: #fff;
  line-height: 20px;
  overflow: visible;
  margin: 0;
  white-space: pre-wrap;
  font-family: Helvetica, Arial, sans-serif;
  overflow-wrap: anywhere;
}

.app ::v-deep  .group-members {
  overflow-y: auto;
}

.app ::v-deep  .group-members-padding-container {
  padding: 15px;
}

.app ::v-deep  .group-members .group-members-groups-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  font-size: 12px;
}

.app ::v-deep  .group-members .group-members-section-header {
  font-size: 14px;
  margin-bottom: 5px;
}

.app ::v-deep  .group-members .group-members-group-bubble {
  font-size: 12px;
  height: 26px;
  padding: 2px 8px;
  border-radius: 24px;
  background: #E1E4EC;
  margin-right: 6px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app ::v-deep  .group-members .initials {
  width: 36px;
  border-radius: 50%;
  padding: 0 4px;
}

.app ::v-deep  .message-recipients-screen {
  height: 100%;
  background: #FFF;
  width: 100%;
}

.app ::v-deep  .message-recipients-screen .message-recipients-container {
  padding: 15px;
}

.app ::v-deep  .message-recipients-screen .filter-buttons-container {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.app ::v-deep  .message-recipients-screen .filter-button {
  font-size: 13px;
  padding: 7px 10px;
  border: 1px solid rgb(217, 227, 233);
  border-radius: 5px;
  text-transform: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  user-select: none;
  max-width: 150px;
}

.app ::v-deep  .message-recipients-screen .filter-button.active {
  border-color: #4d88ff;
}

.app ::v-deep  .message-recipients-screen .filter-button-top {
  padding-bottom: 5px;
  display: flex;
  align-items: center;
}

.app ::v-deep  .message-recipients-screen .filter-button-amount {
  margin-left: 10px;
  padding-top: 2px;
}

.app ::v-deep  .message-recipients-screen .button-icon {
  width: 15px;
}

.app ::v-deep  .message-recipients-screen .no-results-message {
  font-size: 13px;
  padding: 0 15px 15px 15px;
}

.app ::v-deep  .sending-container {
  background: #FFF;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.app ::v-deep  .done-selecting-button {
  cursor: pointer;
  color: #FFF;
  font-size: 15px;
  text-align: center;
  margin-left: auto;
}

.app ::v-deep  .not-selecting {
  display: flex;
  flex-grow: 1;
}

.app ::v-deep  .new-message-container {
  padding: 15px 15px 15px 15px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.app ::v-deep  .new-message-container-grow {
  flex-grow: 1;
}

.app ::v-deep  .new-message-container .new-message-heading {
  display: flex;
  user-select: none;
  align-items: center;
  padding: 5px 0;
}

.app ::v-deep  .new-message-container .new-message-heading-text {
  font-size: 14px;
}

.app ::v-deep  .new-message-container .new-message-heading-icon-container {
  margin-left: 10px;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  background: #4487fd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app ::v-deep  .new-message-container .new-message-loading-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  z-index: 400;
}

.app ::v-deep  .new-message-container .new-message-heading-icon {
  fill: #FFF;
  height: 15px;
}

.app ::v-deep  .new-message-container .new-message-group-name-input {
  padding: 8px;
  border-radius: 10px;
  border: 1px solid #eee;
}

.app ::v-deep  .select-recipients-container .recipient-category-buttons {
  padding-top: 16px;
  display: flex;
  justify-content: center;
  margin: 0 auto 15px auto;
  width: 140px;
}

.app ::v-deep  .select-recipients-container .recipient-category-button {
  padding: 6px 26px;
  color: #4c5158;
  border-radius: 8px;
}

.app ::v-deep  .select-recipients-container .recipient-category-button.active {
  background: #4488FF;
  color: #FFF;
}

.app ::v-deep  .select-recipients-container .search-person-form {
  margin: 18px 0;
}

.app ::v-deep  .search-person-input {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #eee;
}

.app ::v-deep  .group-selection-section {
  margin-bottom: 10px;
}

.app ::v-deep  .group-selection-types-container {
  width: 100%;
  display: flex;
  position: relative;
  flex-wrap: wrap;
  justify-content: space-between;
}

.app ::v-deep  .group-selection-heading {
  font-size: 14px;
  margin-bottom: 15px;
  color: #1A2742;
}

.app ::v-deep  .group-selection-types-container {
  border: 1px solid #d9e3e9;
  border-radius: 5px;
}

.app ::v-deep  .group-selection-type-container {
  padding: 5px 10px;
  width: 100%;
  text-transform: none;
  display: flex;
  align-items: center;
}

.app ::v-deep  .group-selection-type-container:not(:last-of-type) {
  border-bottom: 1px solid #d9e3e9;
}

.app ::v-deep  .select-group-checkbox {
  margin-right: 4px;
  border: 1px solid #d9e3e9;
  outline: none;
}

.app ::v-deep  .select-group-label {
  font-size: 14px;
  color: #1A2742;
}

.app ::v-deep  .group-selection-classes-list .class-container {
  border: 1px solid #d9e3e9;
  border-radius: 5px;
  margin-bottom: 10px;
}

.app ::v-deep  .group-selection-classes-list .class-header {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 10px;
  font-weight: bold;
}

.app ::v-deep  .group-selection-classes-list .class-container.open .class-header {
  border-bottom: 1px solid #d9e3e9;
}

.app ::v-deep  .group-selection-classes-list .class-name {
  margin-left: 6px;
  color: #1A2742;
}

.app ::v-deep  .group-selection-classes-list .class-dropdown-icon {
  height: 16px;
  margin-left: auto;
}

.app ::v-deep  .group-selection-classes-list .class-body {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 10px;
}

.app ::v-deep  .group-selection-classes-list .dropdown-menu-item {
  margin: 2px 0;
}

.app ::v-deep  .group-selection-classes-list .dropdown-label {
  margin-left: 10px;
  color: #1A2742;
}

.app ::v-deep  .undo-remove {
  height: 45px;
  width: 90%;
  margin: 0 auto;
  padding: 0 8px;
  border-radius: 5px;
  font-weight: bold;

  display: flex;
  align-items: center;
  background: #1A2742;
  justify-content: space-between;

  position: sticky;
  bottom: 16px;
}

.app ::v-deep  .undo-text {
  color: #FFF;
  font-size: 14px;
}

.app ::v-deep  .undo-button {
  text-transform: uppercase;
  color: #4488FF;
}

.app ::v-deep  .message-validation-errors-modal {
  padding: 20px;
}

.app ::v-deep  .confirm-send-modal .confirm-icon {
  height: 60px;
  margin-top: 16px;
}

.app ::v-deep  .confirm-send-modal .confirm-heading {
  font-size: 16px;
  margin: 16px 0;
}

.app ::v-deep  .confirm-send-modal .confirm-detail-container {
  margin-bottom: 15px;
  display: flex;
}

.app ::v-deep  .confirm-send-modal .confirm-detail-container.inset {
  padding-left: 20px;
}

.app ::v-deep  .confirm-send-modal .confirm-detail-container .confirm-message-number {
  font-weight: bold;
}

.app ::v-deep  .confirm-send-modal .confirm-detail-text {
  color: #676d7b;
  margin-bottom: 0;
  font-size: 13px;
  text-align: left;
}

.app ::v-deep  .confirm-send-modal .confirm-detail-icon {
  height: 18px;
  width: 18px;
  margin-right: 10px;
}

.app ::v-deep  .confirm-send-modal .confirm-button-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 5px;
}

.app ::v-deep  .confirm-send-modal .confirm-button {
  padding: 6px 10px;
  border-radius: 5px;
  font-size: 14px;
}

.app ::v-deep  .confirm-send-modal .confirm-button-hollow {
  border: 1px solid #EBECF1;
  color: #6F7785;
  flex-grow: 1;
  margin-right: 15px;
  font-size: 14px;
}

.app ::v-deep  .confirm-send-modal .confirm-button-primary {
  background: #4788FF;
  color: #FFF;
}

.app ::v-deep  .message-success-screen {
  height: 420px;
  display: flex;
  flex-direction: column;
}

.app ::v-deep  .message-success-container {
  padding: 15px;
  position: relative;
  height: 100%;
  box-sizing: border-box;
}

.app ::v-deep  .message-success-content {
  position: absolute;
  width: 100%;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
}

.app ::v-deep  .message-success-link {
  color: #007bff;
  font-size: 14px;
  text-align: center;
}

.app ::v-deep  .modal-background {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.app ::v-deep  .modal-container {
  width: 90%;
  max-width: 280px;
  background: #FFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1500;
  border-radius: 10px;
  max-height: 95%;
  padding: 15px;
}

.app ::v-deep  .modal-illustration {
  height: 100px;
  width: 100%;
  padding-bottom: 10px;
}

.app ::v-deep  .modal-top-right-icon {
  height: 17px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.app ::v-deep  .modal-heading {
  font-weight: bold;
  font-size: 16px;
  padding-bottom: 10px;
  text-align: center;
}

.app ::v-deep  .modal-text {
  font-size: 13px;
  text-align: left;
  padding-bottom: 15px;
}

.app ::v-deep  .modal-buttons {
  display: flex;
  justify-content: center;
}

.app ::v-deep  .modal-button {
  padding: 8px 12px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  min-width: 90px;
  box-sizing: border-box;
  text-align: center;
}

.app ::v-deep  .modal-button.app ::v-deep  .action {
  color: #4d88ff;
  border: 1px solid #4d88ff;
}

.app ::v-deep  .modal-button.app ::v-deep  .normal {
  margin-right: 8px;
  background: #EEE;
}

.app ::v-deep  .modal-button.app ::v-deep  .danger {
  background: #FD5061;
  color: #FFF;
}

.app ::v-deep  .modal-list {
  text-align: left;
  font-size: 13px;
  padding-left: 20px;
}

.app ::v-deep  .modal-list > li {
  padding-bottom: 8px;
}

.app ::v-deep  .message-form {
  position: relative;
}

.app ::v-deep  .message-form .message-input {
  border-radius: 10px;
  border: 1px solid #eee;
  padding: 13px 45px 13px 13px;
  font-size: 13px;
  margin: 0;
  line-height: 18px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.app ::v-deep  .message-form .message-form-input-component:focus-within {
  padding-bottom: 20px;
}

.app ::v-deep  .message-form .message-form-input-component:focus-within + .message-length-description {
  display: block;
}

.app ::v-deep  .message-form .message-input-shadow {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
}

.app ::v-deep  .message-form .message-input:focus {
  border-color: #659DFF;
  box-shadow: none !important;
}

.app ::v-deep  .message-input:focus + .message-icon {
  fill: #659DFF;
}

.app ::v-deep  .message-form .message-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  height: 15px;
  fill: #6F7785;
  z-index: 3;
}

.app ::v-deep  .message-length-description {
  position: absolute;
  font-size: 12px;
  color: #6F7785;
  cursor: help;
  right: 10px;
  bottom: -2px;
  display: none;
}

.app ::v-deep  .search-person-form {
  position: relative;
}

.app ::v-deep  .search-person-input {
  margin: 0;
}

.app ::v-deep  .search-person-form .search-person-icon {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  height: 28px;
  fill: #6F7785;
  padding: 6px;
}

.app ::v-deep  .recipient-type:not(:last-of-type) {
  border-bottom: 1px solid #eee;
}

.app ::v-deep  .recipient-type-header {
  display: flex;
  align-items: center;
  height: 35px;
  background: #F5F6FA;
  cursor: pointer;
}

.app ::v-deep  .recipient-type-icon {
  height: 14px;
  margin-left: 8px;
}

.app ::v-deep  .recipient-type-heading {
  font-size: 14px;
  margin-left: 8px;
  width: 60px;
  padding-top: 3px;
}

.app ::v-deep  .recipient-type-count {
  font-size: 11px;
  margin-left: auto;
  margin-right: 15px;
}

.app ::v-deep  .selected-recipients-container {
  min-height: 35px;
  max-height: 123px;
  width: 100%;
  border: 1px solid #d9e3e9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  padding: 4px 4px 0 4px;
  overflow-y: auto;
}

.app ::v-deep  .selected-recipients-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.app ::v-deep  .selected-recipient-bubble {
  height: 25px;
  border-radius: 15px;
  background: #E1E4EC;
  margin-bottom: 4px;
  margin-right: 4px;
  display: flex;
  justify-content: center;
  font-size: 12px;
  overflow: hidden;
  padding: 4px 8px;
}

.app ::v-deep  .selected-recipient-text {
  margin-right: 8px;
}

.app ::v-deep  .selected-recipient-icon {
  height: 12px;
  align-self: center;
}

.app ::v-deep  .selected-recipients-total {
  position: absolute;
  bottom: -25px;
  left: 5px;
  font-size: 13px;
  color: #1d1d1d;
}

.app ::v-deep  .clear-selected-recipients-button {
  position: absolute;
  bottom: -25px;
  right: 0;
  color: #FD5061;
  font-size: 13px;
}

.app ::v-deep  .give-consent-container {
  width: 100%;
  background: #ECF3FF;
  border-radius: 5px;
  margin: 15px 0;
  position: relative;
}

.app ::v-deep  .give-consent-loading-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: #ffffff99;
}

.app ::v-deep  .give-consent-container .consent-body {
  padding: 0 12px 12px 12px;
}

.app ::v-deep  .give-consent-container .consent-header {
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
}

.app ::v-deep  .consent-header .header-consent-icon {
  height: 15px;
  fill: #4788FF;
}

.app ::v-deep  .consent-header .header-consent-text {
  margin-left: 15px;
}

.app ::v-deep  .consent-header .header-consent-heading {
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 0;
}

.app ::v-deep  .consent-header .header-consent-subheading {
  font-size: 12px;
  margin-top: 0;
  margin-bottom: 0;
}

.app ::v-deep  .consent-header .header-consent-exit {
  height: 15px;
  margin-left: auto;
}

.app ::v-deep  .give-consent-container .consent-text {
  color: #4e535c;
  font-size: 13px;
}

.app ::v-deep  .consent-button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 6px;
  margin-left: auto;
}

.app ::v-deep  .consent-button-container .consent-button {
  border-radius: 5px;
  border-width: 1px !important;
  padding: 5px 10px;
  margin: 0 auto;
  user-select: none;
}

.app ::v-deep  .widget-footer {
  height: 35px;
  background: #E1E4EC;
  display: flex;
  align-items: center;
  padding: 10px 5px;
  box-sizing: border-box;
  border-top: 1px solid #cacdd4;
}

.app ::v-deep  .widget-footer .footer-item {
  margin-left: 14px;
  height: 100%;
  display: flex;
  align-items: center;
}

.app ::v-deep  .widget-footer .footer-item .footer-item-icon {
  fill: #6F7785;
  height: 14px;
  margin-right: 8px;
}

.app ::v-deep  .widget-footer .footer-item .footer-item-text {
  color: #6F7785;
  font-size: 12px;
}

.app ::v-deep  .bold {
  font-weight: bold;
}

.app ::v-deep  .b-radius0 {
  border-radius: 0 !important;
}

.app ::v-deep  .pointer {
  cursor: pointer;
}

.app ::v-deep  .text-center {
  text-align: center;
}

.app ::v-deep  .text-underline {
  text-decoration: underline;
}

.app ::v-deep  .fill-blue {
  fill: #4488FF;
}

.app ::v-deep  .fill-grey {
  fill: #8C94A6;
}

.app ::v-deep  .fill-green {
  fill: #62C454;
}

.app ::v-deep  .fill-red {
  fill: #ED6A5E;
}

.app ::v-deep  .fill-orange {
  fill: orange;
}

.app ::v-deep  .container-padding {
  padding-left: 15px;
  padding-right: 15px;
  margin-right: auto;
  margin-left: auto;
  width: 100%;
}

</style>
